
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("d1p2I", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $abC4X = parcelRequire("abC4X");


var $5dK2X = parcelRequire("5dK2X");




parcelRequire("42omo");

const $1fbb045fdeaef17c$export$f370712d0ce7173b = ()=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        "data-testid": "navigation-empty-state--generic-error-icon",
        width: "57",
        height: "53",
        viewBox: "0 0 57 53",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                d: "M0 52.5871L0.0314182 52.6499H56.8739L56.9088 52.5871L28.4544 0L0 52.5871Z",
                fill: "#DDDEE1"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M27.2725 38.0368V18.8333H29.8313V38.0368H27.2725Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M28.0814 41.2098C28.2675 41.1764 28.4451 41.1665 28.5973 41.1665C28.7583 41.1665 28.9179 41.1777 29.0781 41.2023L29.084 41.2032L29.0899 41.2042C30.1047 41.37 30.9494 42.0762 31.154 43.2046C31.19 43.3958 31.1998 43.5794 31.1998 43.7306C31.1998 43.8478 31.1939 43.9799 31.1754 44.1197V44.1412L31.1552 44.2533C30.9533 45.3786 30.1106 46.0937 29.0899 46.2604L29.084 46.2614L29.0781 46.2623C28.9179 46.287 28.7583 46.2981 28.5973 46.2981C28.444 46.2981 28.2649 46.2881 28.0772 46.2541C27.0757 46.0805 26.2351 45.3807 26.0303 44.2574C25.9948 44.0692 25.9844 43.8932 25.9844 43.7341C25.9844 43.5767 25.9945 43.3951 26.0311 43.2033C26.2382 42.0971 27.0613 41.3814 28.0814 41.2098ZM28.5432 43.7274C28.5432 43.7295 28.5432 43.7318 28.5432 43.7341C28.5432 43.7352 28.5432 43.7362 28.5432 43.7373C28.5444 43.7374 28.5456 43.7375 28.547 43.7376C28.559 43.7385 28.5757 43.7393 28.5973 43.7393C28.6137 43.7393 28.6281 43.7389 28.6409 43.7381C28.6409 43.7357 28.641 43.7332 28.641 43.7306C28.641 43.7292 28.641 43.7278 28.6409 43.7265C28.6282 43.7258 28.6137 43.7253 28.5973 43.7253C28.5757 43.7253 28.559 43.7261 28.547 43.727C28.5457 43.7272 28.5444 43.7273 28.5432 43.7274Z",
                fill: "white"
            })
        ]
    });
};


const $d562a938958ff7a0$var$styles = {
    textWrapper: "_195g1wug _p12fo8uj _1e0c1o8l"
};
function $d562a938958ff7a0$export$618cc98292cae482({ testId: testId = 'navigation-empty-state', renderImage: renderImage = ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $1fbb045fdeaef17c$export$f370712d0ce7173b), {}), description: description, ...restProps }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $abC4X.default), {
        ...restProps,
        testId: testId,
        renderImage: renderImage,
        headingLevel: 3,
        headingSize: "xsmall",
        description: /*#__PURE__*/ (0, $l998X.jsx)("span", {
            className: (0, $gMc0m.default)([
                $d562a938958ff7a0$var$styles.textWrapper
            ]),
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $5dK2X.default), {
                size: "small",
                color: "color.text.subtle",
                children: description
            })
        })
    });
}
module.exports["NavEmptyState"] = $d562a938958ff7a0$export$618cc98292cae482;

});

parcelRegister("dBtY8", function(module, exports) {
/**
 * Constants representing locations within the navigation system where errors might occur.
 * These help in identifying the source of errors for logging and debugging purposes.
 */ const $62b96c634929dcc9$export$98b0f7a0d3bb5010 = 'customization-modal';
const $62b96c634929dcc9$export$980ebe5373108eff = 'drag-and-drop';
const $62b96c634929dcc9$export$f7d1e5ad9f9f300d = 'global-more-menu';
const $62b96c634929dcc9$export$1cb3fe63ec81f460 = 'global-shortcuts';
const $62b96c634929dcc9$export$29208be8b6408bd4 = 'global-side-navigation';
const $62b96c634929dcc9$export$649c709379c80e01 = 'global-side-navigation-item';
module.exports["ERROR_LOCATION__CUSTOMIZATION_MODAL"] = $62b96c634929dcc9$export$98b0f7a0d3bb5010;
module.exports["ERROR_LOCATION__DRAG_AND_DROP"] = $62b96c634929dcc9$export$980ebe5373108eff;
module.exports["ERROR_LOCATION__GLOBAL_MORE_MENU"] = $62b96c634929dcc9$export$f7d1e5ad9f9f300d;
module.exports["ERROR_LOCATION__GLOBAL_SHORTCUTS"] = $62b96c634929dcc9$export$1cb3fe63ec81f460;
module.exports["ERROR_LOCATION__GLOBAL_SIDE_NAVIGATION"] = $62b96c634929dcc9$export$29208be8b6408bd4;
module.exports["ERROR_LOCATION__GSN_NAV_ITEM_ACTIONS"] = $62b96c634929dcc9$export$649c709379c80e01;

});

parcelRegister("5xxOu", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $lAJUP = parcelRequire("lAJUP");


var $8C5kA = parcelRequire("8C5kA");


var $dpPtd = parcelRequire("dpPtd");




parcelRequire("42omo");


var $keVvA = parcelRequire("keVvA");


var $eB7BJ = parcelRequire("eB7BJ");

// https://parceljs.org/features/dependency-resolution/#glob-specifiers

const $c667adb400559b66$export$3770c7a7737d463c = {
    en: ()=>Promise.resolve((parcelRequire("eB7BJ")))
};


function $c5e5f2aa3b0d680d$export$2f688dfcc031530a({ children: children }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $keVvA.default), {
        defaultMessages: (0, $eB7BJ.default),
        loaderFn: $c5e5f2aa3b0d680d$var$fetchMessagesForLocale,
        children: children
    });
}
async function $c5e5f2aa3b0d680d$var$fetchMessagesForLocale(locale) {
    try {
        // Fallback to the generic locale if specified one is not found
        const languageLocale = locale in (0, $c667adb400559b66$export$3770c7a7737d463c) ? locale : locale.split(/[-_]/)[0] || '';
        // Dynamic import of the locale file
        const localeMessages = await (0, $c667adb400559b66$export$3770c7a7737d463c)[languageLocale]?.();
        return localeMessages?.default ?? (0, $eB7BJ.default);
    } catch  {
    // ignore
    }
    return 0, $eB7BJ.default;
}



var $dBtY8 = parcelRequire("dBtY8");


var $cgtv4 = parcelRequire("cgtv4");

const $37092a2e7b1ec0f4$export$628f6f7219a6b8b6 = (0, $cgtv4.defineMessages)({
    header: {
        id: "navigation.error.header.default.non-final",
        defaultMessage: "We couldn\u2019t load this content"
    },
    description: {
        id: "navigation.error.description.default.non-final",
        defaultMessage: "Refresh the page and try again"
    }
});
const $37092a2e7b1ec0f4$export$8587940f17f4d26 = (0, $cgtv4.defineMessages)({
    header: {
        id: "navigation.error.header.customization-modal.non-final",
        defaultMessage: "We couldn\u2019t load your customization options"
    },
    description: {
        id: "navigation.error.description.customization-modal.non-final",
        defaultMessage: "Refresh the page and try again"
    }
});
const $37092a2e7b1ec0f4$export$60436671aeff828f = (0, $cgtv4.defineMessages)({
    header: {
        id: "navigation.error.header.global-shortcuts.non-final",
        defaultMessage: "We couldn\u2019t load the app"
    },
    description: {
        id: "navigation.error.description.global-shortcuts.non-final",
        defaultMessage: "Refresh the page and try again"
    }
});
const $37092a2e7b1ec0f4$export$9cce36fc218ef04c = (0, $cgtv4.defineMessages)({
    header: {
        id: "navigation.error.header.global-more-menu.non-final",
        defaultMessage: "We couldn\u2019t load more options"
    },
    description: {
        id: "navigation.error.description.global-more-menu.non-final",
        defaultMessage: "Refresh the page and try again"
    }
});
const $37092a2e7b1ec0f4$export$9483ff6124cf0a32 = (0, $cgtv4.defineMessages)({
    header: {
        id: "navigation.error.header.global-side-navigation.non-final",
        defaultMessage: "We couldn\u2019t load the sidebar"
    },
    description: {
        id: "navigation.error.description.global-side-navigation.non-final",
        defaultMessage: "Refresh the page and try again"
    }
});
const $37092a2e7b1ec0f4$export$18eaee65a8fa9237 = (0, $cgtv4.defineMessages)({
    header: {
        id: "navigation.error.header.global-side-navigation-nav-item-actions.non-final",
        defaultMessage: "We couldn\u2019t load more actions"
    },
    description: {
        id: "navigation.error.description.global-side-navigation-nav-item-actions.non-final",
        defaultMessage: "Refresh the page and try again"
    }
});
const $37092a2e7b1ec0f4$export$a8585c3005ff8118 = (0, $cgtv4.defineMessages)({
    header: {
        id: "navigation.error.ui.header.drag-and-drop.non-final",
        defaultMessage: "We couldn\u2019t complete this action"
    },
    description: {
        id: "navigation.error.ui.description.drag-and-drop.non-final",
        defaultMessage: "Refresh the page and try again"
    }
});


function $fb18a687e517ca8b$export$dc82eac224ce9480(location) {
    switch(location){
        case 0, $dBtY8.ERROR_LOCATION__CUSTOMIZATION_MODAL:
            return 0, $37092a2e7b1ec0f4$export$8587940f17f4d26;
        case 0, $dBtY8.ERROR_LOCATION__DRAG_AND_DROP:
            return 0, $37092a2e7b1ec0f4$export$a8585c3005ff8118;
        case 0, $dBtY8.ERROR_LOCATION__GLOBAL_MORE_MENU:
            return 0, $37092a2e7b1ec0f4$export$9cce36fc218ef04c;
        case 0, $dBtY8.ERROR_LOCATION__GLOBAL_SHORTCUTS:
            return 0, $37092a2e7b1ec0f4$export$60436671aeff828f;
        case 0, $dBtY8.ERROR_LOCATION__GLOBAL_SIDE_NAVIGATION:
            return 0, $37092a2e7b1ec0f4$export$9483ff6124cf0a32;
        case 0, $dBtY8.ERROR_LOCATION__GSN_NAV_ITEM_ACTIONS:
            return 0, $37092a2e7b1ec0f4$export$18eaee65a8fa9237;
        default:
            return 0, $37092a2e7b1ec0f4$export$628f6f7219a6b8b6;
    }
}



var $5IDSL = parcelRequire("5IDSL");











var $bRp3h = parcelRequire("bRp3h");

function $a32d3e2214df8275$export$ad59d437e6db3634({ showFlags: showFlags = false }) {
    const { showFlag: showFlag } = (0, $dpPtd.useFlags)();
    const flags = (0, $42omo.useMemo)(()=>({
            showFailure: ({ title: title, description: description, actions: actions })=>{
                return showFlag({
                    actions: actions,
                    description: description,
                    id: $a32d3e2214df8275$var$flagsIds.failure,
                    isAutoDismiss: true,
                    icon: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bRp3h))), {
                        label: "Failure",
                        spacing: "spacious"
                    }),
                    testId: $a32d3e2214df8275$var$flagsIds.failure,
                    title: title
                });
            }
        }), [
        showFlag
    ]);
    return !showFlags ? undefined : flags;
}
const $a32d3e2214df8275$var$flagsIds = {
    failure: 'nav-error-boundary-failure-flag'
};












var $d1p2I = parcelRequire("d1p2I");


var $4NsV7 = parcelRequire("4NsV7");


function $08962ae18cab1bac$export$ed65a7143a39e5b6({ disableAnalytics: disableAnalytics, errorFallbackUI: errorFallbackUI, errorActionUI: errorActionUI, location: location }) {
    const intl = (0, $8C5kA.default)();
    const { fireEvent: fireEvent } = (0, $4NsV7.useAnalyticsEvents)();
    const { header: header, description: description } = (0, $fb18a687e517ca8b$export$dc82eac224ce9480)(location);
    (0, $42omo.useLayoutEffect)(()=>{
        if (!disableAnalytics) fireEvent('ui.errorBoundary.viewed.errorBoundaryUI', {
            location: location,
            isFallbackUI: !!errorFallbackUI
        });
    }, [
        disableAnalytics,
        errorFallbackUI,
        fireEvent,
        location
    ]);
    // If a custom fallback UI is provided, render it directly at risk of consumer
    if (errorFallbackUI) return errorFallbackUI({
        header: intl.formatMessage(header),
        description: intl.formatMessage(description)
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $d1p2I.NavEmptyState), {
        testId: "navigation-error-boundary-ui",
        header: intl.formatMessage(header),
        description: intl.formatMessage(description),
        primaryAction: errorActionUI
    });
}


function $4c2fb4ef44ce22b7$export$afc779e659fd533f(props) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $c5e5f2aa3b0d680d$export$2f688dfcc031530a), {
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $dpPtd.FlagsProvider), {
            children: /*#__PURE__*/ (0, $l998X.jsx)($4c2fb4ef44ce22b7$var$InnerErrorBoundary, {
                ...props
            })
        })
    });
}
function $4c2fb4ef44ce22b7$var$InnerErrorBoundary({ disableAnalytics: disableAnalytics = false, disableSentry: disableSentry = false, errorActionUI: errorActionUI, errorFallbackUI: errorFallbackUI, interactionId: interactionId, location: location = 'unknown', onError: onError, sentryConfig: sentryConfig, showFlags: showFlags, silent: silent, children: children }) {
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { header: flagTitle, description: flagDescription } = (0, $fb18a687e517ca8b$export$dc82eac224ce9480)(location);
    const flags = (0, $a32d3e2214df8275$export$ad59d437e6db3634)({
        showFlags: showFlags
    });
    const onErrorUIHandler = (0, $42omo.useCallback)((error)=>{
        // Show failure flag if enabled
        flags?.showFailure?.({
            title: formatMessage(flagTitle),
            description: formatMessage(flagDescription)
        });
        onError?.(error);
    }, [
        flagDescription,
        flagTitle,
        flags,
        formatMessage,
        onError
    ]);
    const { handleError: handleError } = (0, $5IDSL.useNavBoundaryContext)({
        disableAnalytics: disableAnalytics,
        disableSentry: disableSentry,
        interactionId: interactionId,
        location: location,
        onError: onErrorUIHandler,
        sentryConfig: sentryConfig
    });
    // When `silent` is true or `flags` are enabled, we don't want to show any UI on error
    const errorComponent = silent || flags ? null : /*#__PURE__*/ (0, $l998X.jsx)((0, $08962ae18cab1bac$export$ed65a7143a39e5b6), {
        disableAnalytics: disableAnalytics,
        errorActionUI: errorActionUI,
        errorFallbackUI: errorFallbackUI,
        location: location
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $lAJUP.ErrorBoundary), {
        onError: handleError,
        fallback: errorComponent,
        children: children
    });
}
module.exports["NavErrorBoundary"] = $4c2fb4ef44ce22b7$export$afc779e659fd533f;

});

parcelRegister("eB7BJ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $d4d83780c7949fa7$export$2e2bcd8739ae039);
var $d4d83780c7949fa7$export$2e2bcd8739ae039 = {};

});

parcelRegister("5IDSL", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dh538 = parcelRequire("dh538");


var $4NsV7 = parcelRequire("4NsV7");





var $k3i2h = parcelRequire("k3i2h");

var $ffG6S = parcelRequire("ffG6S");







// Navigation-experience Sentry DSN
const $6492eee3ae5f6cb2$export$6faa4a850bc4d0ce = 'https://b8c4ebbdd822beb92561fea2a46d2146@o55978.ingest.us.sentry.io/4510463033081856';
const $6492eee3ae5f6cb2$export$eafddbd5a5d6fa6a = 'afe-navigation-experience';
const $6492eee3ae5f6cb2$export$52d764e0fd2a1dc5 = {
    whitelistUrls: [
        /atl-paas.net/,
        /localhost/
    ],
    ignoreErrors: [
        /^SentryIgnore:/
    ],
    ignoreUrls: [
        /extensions\//i,
        /^chrome:\/\//i
    ],
    attachStacktrace: true
};
const $6492eee3ae5f6cb2$export$9f448e5ee63d7699 = 'navigation';


function $21fcd6b6f4d6fe49$export$aa1a786276a57667(isSentryDisabled, config = {}, location) {
    const { fireEvent: fireEvent } = (0, $4NsV7.useAnalyticsEvents)();
    const sentryClient = $k3i2h.getCurrentHub().getClient();
    const fireAnalyticsEvent = (0, $42omo.useCallback)((reason)=>{
        fireEvent('operational.initSentry.failed', {
            reason: reason,
            location: location
        });
    }, [
        fireEvent,
        location
    ]);
    const setupSentry = (0, $42omo.useCallback)(()=>{
        if (!sentryClient && !isSentryDisabled && (0, $dh538.fg)('navx-1574-enable-sentry-logs')) $21fcd6b6f4d6fe49$var$setupSentryClient(config, fireAnalyticsEvent);
    }, [
        sentryClient,
        isSentryDisabled,
        config,
        fireAnalyticsEvent
    ]);
    (0, $42omo.useEffect)(()=>{
        setupSentry();
    }, [
        setupSentry
    ]);
    return {
        sentryInitialised: !!sentryClient,
        sentryClient: sentryClient
    };
}
function $21fcd6b6f4d6fe49$var$setupSentryClient({ dsn: dsn = (0, $6492eee3ae5f6cb2$export$6faa4a850bc4d0ce), env: env, product: product = (0, $6492eee3ae5f6cb2$export$9f448e5ee63d7699), teamName: teamName = (0, $6492eee3ae5f6cb2$export$eafddbd5a5d6fa6a) }, fireEvent) {
    const environment = window.location.href.includes('localhost') ? 'dev' : env ?? 'prod';
    try {
        $ffG6S.init({
            ...(0, $6492eee3ae5f6cb2$export$52d764e0fd2a1dc5),
            dsn: dsn,
            initialScope: {
                tags: {
                    renderMode: teamName || 'unknown',
                    productBuild: // @ts-ignore Jira  - window.BUILD_KEY, confluence - window.__buildInfo
                    window.BUILD_KEY || window.__buildInfo?.FRONTEND_VERSION || 'unknown',
                    product: product
                }
            },
            environment: environment
        });
    } catch (error) {
        fireEvent && fireEvent(error instanceof Error ? error.message : 'unknown');
    }
}


function $b5e919069742162a$export$335b0c12ccf77339({ location: location = 'unknown', disableSentry: disableSentry = false, disableAnalytics: disableAnalytics = false, sentryConfig: sentryConfig, onError: onError } = {}) {
    const { fireEvent: fireEvent } = (0, $4NsV7.useAnalyticsEvents)();
    const { sentryInitialised: sentryInitialised, sentryClient: sentryClient } = (0, $21fcd6b6f4d6fe49$export$aa1a786276a57667)(disableSentry, sentryConfig, location);
    const handleError = (0, $42omo.useCallback)((error)=>{
        // Send events to sentry
        if (sentryInitialised && sentryClient && (0, $dh538.fg)('navx-1574-enable-sentry-logs')) try {
            sentryClient.captureException(error, {
                data: {
                    location: location
                }
            });
        } catch (error) {
            // Log failure to send to Sentry
            fireEvent('operational.logToSentry.failed', {
                location: location,
                reason: error instanceof Error ? error.message : 'unknown'
            });
        }
        // Fire Analytics event
        if (!disableAnalytics) fireEvent('operational.errorBoundary.unhandledErrorCaught', {
            location: location,
            errorMessage: error.message,
            errorStack: error.stack || 'no stack trace'
        });
        // handler Callback
        onError?.(error);
    }, [
        sentryInitialised,
        sentryClient,
        disableAnalytics,
        onError,
        location,
        fireEvent
    ]);
    return {
        handleError: handleError
    };
}
module.exports["useNavBoundaryContext"] = $b5e919069742162a$export$335b0c12ccf77339;

});

parcelRegister("49YLc", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $1I43V = parcelRequire("1I43V");

const $45703bb7386f8863$export$53903226fff06fbb = (featureFlagName, functionTrue, functionFalse)=>(0, $1I43V.functionWithCondition)(()=>(0, $dh538.fg)(featureFlagName), functionTrue, functionFalse);
module.exports["functionWithFG"] = $45703bb7386f8863$export$53903226fff06fbb;

});

parcelRegister("cmWXZ", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dh538 = parcelRequire("dh538");


var $4jETc = parcelRequire("4jETc");


var $6lFYf = parcelRequire("6lFYf");


var $6Tx9o = parcelRequire("6Tx9o");





var $g58eM = parcelRequire("g58eM");


var $lzcvT = parcelRequire("lzcvT");




const $4c257adbcfd5a3a3$var$MILLISECONDS_IN_A_DAY = 86400000;
function $4c257adbcfd5a3a3$export$416492d1a5f46c79(firstDate, secondDate) {
    if (!$4c257adbcfd5a3a3$var$isValidDate(firstDate) || !$4c257adbcfd5a3a3$var$isValidDate(secondDate)) return -1;
    const first = firstDate.getTime();
    const second = secondDate.getTime();
    const millisecondsBetween = Math.abs(second - first);
    return Math.round(millisecondsBetween / $4c257adbcfd5a3a3$var$MILLISECONDS_IN_A_DAY);
}
// https://stackoverflow.com/questions/643782/how-to-check-whether-an-object-is-a-date/44198641#44198641
function $4c257adbcfd5a3a3$var$isValidDate(date) {
    return date && Object.prototype.toString.call(date) === '[object Date]' && !isNaN(date);
}


function $c62ed403d6258f10$export$3e8bbf689f8e6cad(record, sortFunction) {
    for(const key in record)if (Array.isArray(record[key])) record[key].sort(sortFunction); // Sorts alphabetically or numerically by default
    return record;
}



var $iAFAo = parcelRequire("iAFAo");





var $ik19A = parcelRequire("ik19A");

function $e49dbd0b56d8db18$var$checkIsRecentEndUserActivatedProduct(productType, endUserActivationDate) {
    const parsedEndUserActivationDate = Date.parse(endUserActivationDate || '');
    if (!endUserActivationDate || isNaN(parsedEndUserActivationDate) || ![
        'CONFLUENCE',
        'JIRA_SERVICE_DESK',
        'JIRA_PRODUCT_DISCOVERY'
    ].includes(productType)) return false;
    const days = (0, $4c257adbcfd5a3a3$export$416492d1a5f46c79)(new Date(parsedEndUserActivationDate), new Date());
    return days >= 0 && days <= (0, $4jETc.DAYS_END_USER_ACTIVE_PRODUCT_CONSIDERED_NEW);
}
function $e49dbd0b56d8db18$var$checkIsNewlyAutoProvisioned(autoProvisionDate) {
    let isConsideredNew = false;
    if (autoProvisionDate) {
        const days = (0, $4c257adbcfd5a3a3$export$416492d1a5f46c79)(new Date(autoProvisionDate), new Date());
        isConsideredNew = days >= 0 && days <= (0, $4jETc.DAYS_AUTO_PROVISIONED_ITEM_CONSIDERED_NEW);
    }
    return isConsideredNew;
}
function $e49dbd0b56d8db18$var$checkShouldRemoveJWM(productType) {
    return [
        'JIRA_SOFTWARE',
        'JIRA_PRODUCT_DISCOVERY',
        'JIRA_SERVICE_DESK'
    ].includes(productType);
}
const $e49dbd0b56d8db18$var$flightdeckClient = new (0, $g58eM.default)('atlassian-navigagtion-bff-data-provider');
function $e49dbd0b56d8db18$export$79322ba781a26ce1({ cloudId: cloudId, orgId: orgId, forceStatic: forceStatic }) {
    const { items: items } = (0, $6Tx9o.useCache)();
    const { setStatus: setStatus } = (0, $ik19A.useStatus)();
    const [fdResponse, setFdResponse] = (0, $42omo.useState)(null);
    const [productConfig, setProductConfig] = (0, $42omo.useState)(null);
    (0, $42omo.useEffect)(()=>{
        const getFlightdeckData = async ()=>{
            try {
                setStatus((0, $4jETc.RequestStatus).LOADING, (0, $4jETc.FLIGHTDECK_REQUEST_STATUS_KEY));
                const fdResponse = await $e49dbd0b56d8db18$var$flightdeckClient.fetchConfigFromFlightDeck({
                    // app-switcher-fe is currently the only valid name that is configured
                    // in Flightdeck
                    name: 'app-switcher-fe',
                    // This should get updated to be based on the supplied consumer
                    // name: `app-global-shortcuts-${consumer}-fe`,
                    dimensions: {
                        environmentType: 'prod',
                        perimeter: (0, $lzcvT.isFedRamp)() ? 'fedramp-moderate' : 'commercial'
                    }
                });
                setFdResponse(fdResponse);
                setStatus((0, $4jETc.RequestStatus).COMPLETE, (0, $4jETc.FLIGHTDECK_REQUEST_STATUS_KEY));
            } catch (e) {
                setStatus((0, $4jETc.RequestStatus).ERROR, (0, $4jETc.FLIGHTDECK_REQUEST_STATUS_KEY));
            }
        };
        if (!fdResponse && !forceStatic) getFlightdeckData();
    }, [
        fdResponse,
        setStatus,
        forceStatic
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!fdResponse) return;
        const config = {};
        for (const product of fdResponse.products){
            const { apsKey: apsKey, tcsProductKey: tcsProductKey, siteUrlSuffix: siteUrlSuffix, displayName: displayName, rebrandedDisplayName: rebrandedDisplayName, subtitle: subtitle, ordinal: ordinal, iconKey: iconKey, rebrandedIconKey: rebrandedIconKey } = product;
            config[apsKey] = {
                key: !!tcsProductKey ? tcsProductKey : apsKey.toLowerCase(),
                siteUrlSuffix: siteUrlSuffix,
                ordinal: ordinal,
                label: (0, $iAFAo.formatText)(displayName),
                rebrandedLabel: rebrandedDisplayName && (0, $iAFAo.formatText)(rebrandedDisplayName),
                description: (0, $iAFAo.formatText)(subtitle),
                iconKey: iconKey,
                rebrandedIconKey: rebrandedIconKey
            };
            // TODO: remove this once Asset app becomes standalone app
            if (apsKey === 'JIRA_SERVICE_DESK' && !config[0, $4jETc.ASSETS_APP_KEY]) config[0, $4jETc.ASSETS_APP_KEY] = {
                key: (0, $4jETc.ASSETS_APP_KEY),
                siteUrlSuffix: '/jira/assets',
                ordinal: ordinal + 0.1,
                label: (0, $iAFAo.formatText)('Assets'),
                iconKey: 'assets'
            };
        }
        setProductConfig(config);
    }, [
        fdResponse
    ]);
    const getProductLinkForItem = (0, $42omo.useCallback)((productType, siteUrl, productUrl)=>{
        if (productUrl) return productUrl;
        const siteSuffix = productConfig?.[productType]?.siteUrlSuffix;
        return `${siteUrl}${siteSuffix}`;
    }, [
        productConfig
    ]);
    const productLinks = (0, $42omo.useMemo)(()=>{
        const products = {};
        const shouldRemoveJWM = items.some((item)=>{
            return (item.availableProducts || []).some(({ productType: productType })=>$e49dbd0b56d8db18$var$checkShouldRemoveJWM(productType));
        });
        items.forEach((item)=>{
            const { availableProducts: availableProducts = [], cloudId: cachedItemCloudId, avatar: avatar, url: siteUrl, displayName: displayName, org: org } = item;
            // only apply org level filtering if org data is available
            if (org && orgId && org.id !== orgId) return;
            availableProducts.forEach((product)=>{
                const { autoProvisionDate: autoProvisionDate, companyHubName: companyHubName, isCompanyHubPublishedAndPremium: isCompanyHubPublishedAndPremium, endUserActivationDate: endUserActivationDate, url: productUrl } = product;
                let { productType: productType } = product;
                const isExcludeJiraBusiness = productType === 'JIRA_BUSINESS' && !shouldRemoveJWM;
                // if a site has JWM only and no other Jiras, JWM needs to appear under "Jira"
                // to ensure that this happens, we set JSM's productType to 'JIRA_SOFTWARE'
                // this will ensure that JWM is not removed, even if another site has JSW/JPD/JSM
                if (isExcludeJiraBusiness) productType = 'JIRA_SOFTWARE';
                if (!products[productType]) products[productType] = [];
                if (!isExcludeJiraBusiness) products[productType].push({
                    product: product,
                    isCurrentSite: Boolean(cachedItemCloudId) && cloudId?.toLowerCase() === cachedItemCloudId?.toLowerCase(),
                    isCompanyHubPublishedAndPremium: isCompanyHubPublishedAndPremium,
                    companyHubName: companyHubName,
                    shouldShowNewLozenge: $e49dbd0b56d8db18$var$checkIsRecentEndUserActivatedProduct(productType, endUserActivationDate) || productType !== 'CONFLUENCE' && $e49dbd0b56d8db18$var$checkIsNewlyAutoProvisioned(autoProvisionDate),
                    shouldShowTryLozenge: productType === 'CONFLUENCE' && $e49dbd0b56d8db18$var$checkIsNewlyAutoProvisioned(autoProvisionDate),
                    autoProvisionDate: autoProvisionDate,
                    displayName: displayName,
                    url: getProductLinkForItem(productType, siteUrl, productUrl),
                    avatar: avatar,
                    cloudId: cachedItemCloudId
                });
            });
        });
        return (0, $c62ed403d6258f10$export$3e8bbf689f8e6cad)(products, (a, b)=>{
            return (0, $iAFAo.sortAlphabetically)('asc')(a.displayName, b.displayName);
        });
    }, [
        items,
        orgId,
        cloudId,
        getProductLinkForItem
    ]);
    return {
        productLinks: productLinks
    };
}






var $cdX3N = parcelRequire("cdX3N");

async function $f19027b153d497cf$var$wait(ms) {
    return new Promise((resolve)=>{
        setTimeout(resolve, ms);
    });
}
function $f19027b153d497cf$export$a00b492c9c3c66db({ request: request, cloudId: cloudId, orgId: orgId, product: product, userId: userId, forceStatic: forceStatic }) {
    const { items: cachedItems, addItemsToCache: addItemsToCache, clearCache: clearCache, cacheKey: cacheKey, updateCacheKey: updateCacheKey } = (0, $6Tx9o.useCache)();
    const { setStatus: setStatus, status: status } = (0, $ik19A.useStatus)();
    const { productLinks: productLinks } = (0, $e49dbd0b56d8db18$export$79322ba781a26ce1)({
        cloudId: cloudId,
        orgId: orgId,
        forceStatic: forceStatic
    });
    const { buildURL: buildURL } = (0, $cdX3N.useURLBuilder)({
        cloudId: cloudId,
        userId: userId,
        product: product
    });
    const [error, setError] = (0, $42omo.useState)(null);
    const currentRequest = (0, $42omo.useRef)(null);
    const fetchData = (0, $42omo.useCallback)(async (url, data, attemptCount = 1, successCheck)=>{
        if (url === '') throw new Error('URL is empty');
        setStatus((0, $4jETc.RequestStatus).LOADING, (0, $4jETc.BFF_REQUEST_STATUS_KEY));
        try {
            const response = await (0, $6lFYf.fetchJSON)(url, {});
            switch(response.status){
                case (0, $4jETc.RequestStatus).ERROR:
                    throw response.error;
                case (0, $4jETc.RequestStatus).COMPLETE:
                    if (!successCheck || successCheck(response.data)) {
                        setStatus((0, $4jETc.RequestStatus).COMPLETE, (0, $4jETc.BFF_REQUEST_STATUS_KEY));
                        currentRequest.current = null;
                        return response.data;
                    } else throw new Error('BFF success check failed');
            }
        } catch  {
            const maxAttempts = request?.maxAttempts ?? (0, $4jETc.MAX_ATTEMPTS_DEFAULT);
            if (request?.shouldRetryOnException && attemptCount < maxAttempts) {
                // Introduce longer wait times for each retry attempt
                await $f19027b153d497cf$var$wait((request?.attemptInterval ?? (0, $4jETc.RETRY_INTERVAL_DEFAULT)) * attemptCount);
                return await fetchData(url, data, attemptCount + 1, successCheck);
            } else {
                currentRequest.current = null;
                setStatus((0, $4jETc.RequestStatus).ERROR);
                const err = new Error('Max attempts reached');
                (0, $dh538.fg)('navx-1574-navigation-error-boundary-shortcuts') && setError(err);
                throw err;
            }
        }
    }, [
        request?.attemptInterval,
        request?.maxAttempts,
        request?.shouldRetryOnException,
        setStatus
    ]);
    /**
	 * Helper function to build a URL and fetch data.
	 */ const buildURLAndFetchData = (0, $42omo.useCallback)(async ()=>{
        // Wait for the current request to end before firing another
        if (currentRequest.current) return currentRequest.current;
        const builtUrl = buildURL({});
        if (builtUrl !== '') {
            currentRequest.current = fetchData(builtUrl, undefined, undefined, (result)=>{
                return result.sites && result.sites.length > 0;
            });
            const fetchedData = await currentRequest.current;
            if (fetchedData.sites && fetchedData.sites.length) addItemsToCache(fetchedData.sites);
        }
    }, [
        addItemsToCache,
        buildURL,
        fetchData
    ]);
    return {
        status: status,
        error: error,
        cachedItems: cachedItems,
        cacheKey: cacheKey,
        updateCacheKey: updateCacheKey,
        addItemsToCache: addItemsToCache,
        clearCache: clearCache,
        buildURL: buildURL,
        fetchData: fetchData,
        buildURLAndFetchData: buildURLAndFetchData,
        productLinks: productLinks
    };
}
module.exports["useBFFDataProvider"] = $f19027b153d497cf$export$a00b492c9c3c66db;

});

parcelRegister("k3207", function(module, exports) {
const $c124c8c0b6cfb1b3$export$54a1da5292674ec8 = (workspaceCloudId)=>(item, index, arr)=>{
        const matchedItem = arr.find((productLink)=>{
            return productLink.cloudId === workspaceCloudId;
        });
        // If an item exists in the parent array with the same cloudId,
        // we don't want to show a flyout and instead only want the list
        // of available product links to include the matching cloudId.
        if (matchedItem) return workspaceCloudId === item.cloudId;
        // If the filter gets here we want to only pass the first item
        return index === 0;
    };
module.exports["productLinksWorkspaceCloudIdFilter"] = $c124c8c0b6cfb1b3$export$54a1da5292674ec8;

});

parcelRegister("eYEH3", function(module, exports) {
/* top-level-spacer.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $dqobF = parcelRequire("dqobF");

const $9891db22e2d9223c$var$styles = {
    root: "_4t3iutpp"
}; /**
    * Use this component to create visual separation between the:
    *
    * - global app shortcut section
    * - 'more' button menu item
    * - starred spaces (in Confluence)
    *
    * Only use this component in the top level of the menu,
    * and exercise caution when using it in new situations.
    *
    * This component exists to fulfil product design requirements but has not yet
    * been consolidated into the wider navigation system.
    *
    * It may not exist in the future when global apps are no longer in the side navigation.
    */ 
function $9891db22e2d9223c$export$5776f68925982056() {
    const level = (0, $dqobF.useLevel)();
    (0, $42omo.useEffect)(()=>{}, [
        level
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        className: (0, $gMc0m.default)([
            $9891db22e2d9223c$var$styles.root
        ])
    });
}
module.exports["TopLevelSpacer"] = $9891db22e2d9223c$export$5776f68925982056;

});

parcelRegister("cViGk", function(module, exports) {

var $fYKLM = parcelRequire("fYKLM");

// using a symbol so we can guarantee a key with a unique value
const $e47dc82918f0a9a8$var$uniqueKey = Symbol('list-item-instruction');
const $e47dc82918f0a9a8$var$axisLookup = {
    vertical: {
        start: 'top',
        end: 'bottom',
        size: 'height',
        point: 'y'
    },
    horizontal: {
        start: 'left',
        end: 'right',
        size: 'width',
        point: 'x'
    }
};
function $e47dc82918f0a9a8$var$reorderAndCombine({ client: client, borderBox: borderBox, axis: axis }) {
    const quarterOfSize = borderBox[axis.size] / 4;
    // In the top 1/4: reorder-before
    // On the line: reorder-before to give a slight preference to reordering
    if (client[axis.point] <= borderBox[axis.start] + quarterOfSize) return 'reorder-before';
    // In the bottom 1/4: reorder-after
    // On the line: reorder-after to give a slight preference to reordering
    if (client[axis.point] >= borderBox[axis.end] - quarterOfSize) return 'reorder-after';
    return 'combine';
}
function $e47dc82918f0a9a8$var$reorder({ client: client, borderBox: borderBox, axis: axis }) {
    const halfSize = borderBox[axis.size] / 2;
    // In the top 1/2: reorder-before
    // On the line: reorder-after to give a slight preference to moving forward
    if (client[axis.point] < borderBox[axis.start] + halfSize) return 'reorder-before';
    return 'reorder-after';
}
// Note: not using `memoize-one` as all we need is a cached value.
// We do not need to avoid executing an expensive function.
const $e47dc82918f0a9a8$var$memoizeInstruction = (0, $fYKLM.stable)();
function $e47dc82918f0a9a8$var$isPossible(...values) {
    return values.every((value)=>value === 'available' || value === 'blocked');
}
function $e47dc82918f0a9a8$var$isNotAvailable(...values) {
    return values.every((value)=>value === 'not-available');
}
function $e47dc82918f0a9a8$export$267ad49d812c2c7f(userData, { operations: operations, element: element, input: input, axis: axisValue = 'vertical' }) {
    const client = {
        x: input.clientX,
        y: input.clientY
    };
    const borderBox = element.getBoundingClientRect();
    const axis = $e47dc82918f0a9a8$var$axisLookup[axisValue];
    const combine = operations.combine ?? 'not-available';
    const reorderAbove = operations['reorder-before'] ?? 'not-available';
    const reorderBelow = operations['reorder-after'] ?? 'not-available';
    const operation = (()=>{
        // Combining not possible
        if (!$e47dc82918f0a9a8$var$isPossible(combine)) {
            // can reorder above and below
            if ($e47dc82918f0a9a8$var$isPossible(reorderAbove, reorderBelow)) return $e47dc82918f0a9a8$var$reorder({
                client: client,
                borderBox: borderBox,
                axis: axis
            });
            // can only reorder above
            if ($e47dc82918f0a9a8$var$isPossible(reorderAbove)) return 'reorder-before';
            // can only reorder below
            if ($e47dc82918f0a9a8$var$isPossible(reorderBelow)) return 'reorder-after';
            // no `true` values - no Outcome available.
            return null;
        }
        // combining is available
        const result = $e47dc82918f0a9a8$var$reorderAndCombine({
            client: client,
            borderBox: borderBox,
            axis: axis
        });
        if (result === 'reorder-after') return $e47dc82918f0a9a8$var$isNotAvailable(reorderBelow) ? 'combine' : result;
        if (result === 'reorder-before') return $e47dc82918f0a9a8$var$isNotAvailable(reorderAbove) ? 'combine' : result;
        return result;
    })();
    // We cannot attach an instruction - all values passed where `false` or no values passed
    if (!operation) return userData;
    const instruction = {
        operation: operation,
        blocked: operations[operation] === 'blocked',
        axis: axisValue
    };
    const memoized = $e47dc82918f0a9a8$var$memoizeInstruction(instruction);
    return {
        ...userData,
        [$e47dc82918f0a9a8$var$uniqueKey]: memoized
    };
}
function $e47dc82918f0a9a8$export$c8ffecbe249dc8f8(userData) {
    return userData[$e47dc82918f0a9a8$var$uniqueKey] ?? null;
}
module.exports["attachInstruction"] = $e47dc82918f0a9a8$export$267ad49d812c2c7f;
module.exports["extractInstruction"] = $e47dc82918f0a9a8$export$c8ffecbe249dc8f8;

});

parcelRegister("fdzcy", function(module, exports) {
const $4cf608509dac3bd2$export$72b069d0875dccc = {
    MENU: 'L1MenuGroup',
    SHORTCUTS: 'L1ShortcutsGroup'
};
module.exports["L1_MENU_GROUPS"] = $4cf608509dac3bd2$export$72b069d0875dccc;

});

parcelRegister("6IuK2", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $dRnqM = parcelRequire("dRnqM");

// When a user drags & drops a navigation item, ADS recommends that we flash the item visually, and if the move was
// triggered by keyboard, also set focus to the moved item. This element registry allows GSN to keep track of the
// actual HTML elements of the L1 items, so that we can flash and focus them after the drag & drop action is performed.
// This pattern is recommended by AtlasKit in the side nav drag & drop documentation:
// https://atlassian.design/components/navigation-system/side-nav-items/drag-and-drop#on-drop
const $070361eb324e4c27$var$MORE_MENU_ID = Symbol('moreMenuId');
function $070361eb324e4c27$export$b8d30beb0c187a7() {
    const registry = new Map();
    function registerL1Item({ id: id, element: element }) {
        registry.set(id, element);
        return function cleanup() {
            registry.delete(id);
        };
    }
    function getL1ItemElement(id) {
        return registry.get(id);
    }
    function registerMoreMenuItem(element) {
        return registerL1Item({
            id: $070361eb324e4c27$var$MORE_MENU_ID,
            element: element
        });
    }
    function getMoreMenuElement() {
        return getL1ItemElement($070361eb324e4c27$var$MORE_MENU_ID);
    }
    return {
        registerL1Item: registerL1Item,
        getL1ItemElement: getL1ItemElement,
        registerMoreMenuItem: registerMoreMenuItem,
        getMoreMenuElement: getMoreMenuElement
    };
}
const $070361eb324e4c27$var$ElementRegistryContext = /*#__PURE__*/ (0, $42omo.createContext)(null);
function $070361eb324e4c27$export$ce0cc6a5e9b6a71a({ children: children, registry: registry }) {
    return /*#__PURE__*/ (0, $l998X.jsx)($070361eb324e4c27$var$ElementRegistryContext.Provider, {
        value: registry,
        children: children
    });
}
function $070361eb324e4c27$export$9a176103b34f9da9() {
    const elementRegistry = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useContext($070361eb324e4c27$var$ElementRegistryContext);
    (0, $dRnqM.default)(elementRegistry, 'useElementRegistry must be used within an ElementRegistryProvider');
    return elementRegistry;
}
module.exports["createElementRegistry"] = $070361eb324e4c27$export$b8d30beb0c187a7;
module.exports["ElementRegistryProvider"] = $070361eb324e4c27$export$ce0cc6a5e9b6a71a;
module.exports["useElementRegistry"] = $070361eb324e4c27$export$9a176103b34f9da9;

});

parcelRegister("kkRaq", function(module, exports) {
const $0f77ee396fe887e6$var$l1ItemKey = Symbol('l1ItemKey');
const $0f77ee396fe887e6$var$nestedItemKey = Symbol('nestedItemKey');
const $0f77ee396fe887e6$var$moreMenuKey = Symbol('moreMenuKey');
const $0f77ee396fe887e6$export$a1dfda61267432e5 = (data)=>({
        ...data,
        type: 'menu-item',
        [$0f77ee396fe887e6$var$l1ItemKey]: true
    });
const $0f77ee396fe887e6$export$e9f7c92759d0f281 = (data)=>({
        ...data
    });
const $0f77ee396fe887e6$export$e52c346726a16591 = (data)=>{
    return data[$0f77ee396fe887e6$var$l1ItemKey] === true;
};
const $0f77ee396fe887e6$export$9d9fcc463b545806 = (data, groups)=>{
    return Array.isArray(groups) ? groups.includes(data.group) : groups === data.group;
};
const $0f77ee396fe887e6$export$7960450fbf5a0a72 = Symbol('moreMenuId');
function $0f77ee396fe887e6$export$e74f096ffe08821d() {
    return {
        menuItemId: $0f77ee396fe887e6$export$7960450fbf5a0a72,
        [$0f77ee396fe887e6$var$moreMenuKey]: true
    };
}
function $0f77ee396fe887e6$export$e37de48254c6595e(data) {
    return data[$0f77ee396fe887e6$var$moreMenuKey] === true;
}
const $0f77ee396fe887e6$export$fe7d1a1bab9e2488 = (data)=>({
        ...data,
        type: 'menu-item',
        [$0f77ee396fe887e6$var$nestedItemKey]: true
    });
const $0f77ee396fe887e6$export$db162439b96bd9a8 = (data)=>{
    return {
        ...data,
        [$0f77ee396fe887e6$var$nestedItemKey]: true
    };
};
const $0f77ee396fe887e6$export$23cae75a8064fbc1 = (data)=>{
    return data[$0f77ee396fe887e6$var$nestedItemKey] === true;
};
const $0f77ee396fe887e6$export$a3f9aca82641b845 = (data, groups)=>{
    return Array.isArray(groups) ? groups.includes(data.group) : groups === data.group;
};
const $0f77ee396fe887e6$export$98ff4de2f070152d = {
    MOVE_TO_TOP: 'MOVE_TO_TOP',
    MOVE_UP: 'MOVE_UP',
    MOVE_DOWN: 'MOVE_DOWN',
    MOVE_TO_BOTTOM: 'MOVE_TO_BOTTOM',
    BEFORE: 'reorder-before',
    AFTER: 'reorder-after'
};
module.exports["createL1ItemData"] = $0f77ee396fe887e6$export$a1dfda61267432e5;
module.exports["getL1ItemData"] = $0f77ee396fe887e6$export$e9f7c92759d0f281;
module.exports["isL1ItemData"] = $0f77ee396fe887e6$export$e52c346726a16591;
module.exports["isL1ItemDataInGroup"] = $0f77ee396fe887e6$export$9d9fcc463b545806;
module.exports["getMoreMenuData"] = $0f77ee396fe887e6$export$e74f096ffe08821d;
module.exports["isMoreMenuData"] = $0f77ee396fe887e6$export$e37de48254c6595e;

});

parcelRegister("h0OZ6", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $6mkwk = parcelRequire("6mkwk");


var $bzNqF = parcelRequire("bzNqF");


var $l5LHO = parcelRequire("l5LHO");


var $jjpBv = parcelRequire("jjpBv");


var $fFwtP = parcelRequire("fFwtP");

const $bfeec28731cf41b0$export$34e3b4eaa687835 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ children: children, id: id, isOpen: isOpenControlled, isDefaultOpen: isDefaultOpen = false, onOpenChange: onOpenChange }, forwardedRef)=>{
    const [isOpen, setIsOpen] = (0, $6mkwk.default)(isOpenControlled, ()=>isDefaultOpen);
    const previousIsOpen = (0, $bzNqF.default)(isOpen);
    (0, $42omo.useEffect)(()=>{
        if (previousIsOpen === undefined || previousIsOpen === isOpen) /**
				 * The previous value is `undefined` on initialization, so if it is `undefined` then the value hasn't changed.
				 *
				 * The previous value can be equal to the current one if the component re-renders due to something else changing.
				 *
				 * In both cases the value hasn't changed and we don't want to notify consumers.
				 */ return;
        onOpenChange?.(isOpen);
    }, [
        isOpen,
        onOpenChange,
        previousIsOpen
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $fFwtP.IsOpenContext).Provider, {
        value: isOpen,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $fFwtP.SetIsOpenContext).Provider, {
            value: setIsOpen,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $jjpBv.MenuListItem), {
                ref: forwardedRef,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $l5LHO.Popup), {
                    id: id,
                    isOpen: isOpen,
                    children: children
                })
            })
        })
    });
});
module.exports["FlyoutMenuItem"] = $bfeec28731cf41b0$export$34e3b4eaa687835;

});

parcelRegister("l5LHO", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $dRnqM = parcelRequire("dRnqM");


var $ee7An = parcelRequire("ee7An");


var $c0qxy = parcelRequire("c0qxy");


var $iug2J = parcelRequire("iug2J");


var $if5rb = parcelRequire("if5rb");


var $2xusd = parcelRequire("2xusd");

var $cs0ez = parcelRequire("cs0ez");


var $caX7N = parcelRequire("caX7N");


var $2cdko = parcelRequire("2cdko");


var $fiAWX = parcelRequire("fiAWX");


var $advfQ = parcelRequire("advfQ");

const $9aa4c7c29923f177$var$IsOpenContext = /*#__PURE__*/ (0, $42omo.createContext)(false);
const $9aa4c7c29923f177$var$IdContext = /*#__PURE__*/ (0, $42omo.createContext)(undefined);
const $9aa4c7c29923f177$var$TriggerRefContext = /*#__PURE__*/ (0, $42omo.createContext)(null);
const $9aa4c7c29923f177$var$SetTriggerRefContext = /*#__PURE__*/ (0, $42omo.createContext)((0, $ee7An.default));
const $9aa4c7c29923f177$var$EnsureIsInsidePopupContext = /*#__PURE__*/ (0, $42omo.createContext)(false);
// Used to ensure popup sub-components are used within a Popup
// and provide a useful error message if not.
const $9aa4c7c29923f177$var$useEnsureIsInsidePopup = ()=>{
    const context = (0, $42omo.useContext)($9aa4c7c29923f177$var$EnsureIsInsidePopupContext);
    (0, $dRnqM.default)(context, 'PopupTrigger and PopupContent components must be used within a Popup');
};
const $9aa4c7c29923f177$export$129a32eedafa97c5 = ({ children: children, id: providedId, isOpen: isOpen = false })=>{
    const [triggerRef, setTriggerRef] = (0, $42omo.useState)(null);
    const generatedId = (0, $c0qxy.useId)();
    const id = providedId || generatedId;
    return /*#__PURE__*/ (0, $l998X.jsx)($9aa4c7c29923f177$var$EnsureIsInsidePopupContext.Provider, {
        value: true,
        children: /*#__PURE__*/ (0, $l998X.jsx)($9aa4c7c29923f177$var$IdContext.Provider, {
            value: id,
            children: /*#__PURE__*/ (0, $l998X.jsx)($9aa4c7c29923f177$var$TriggerRefContext.Provider, {
                value: triggerRef,
                children: /*#__PURE__*/ (0, $l998X.jsx)($9aa4c7c29923f177$var$SetTriggerRefContext.Provider, {
                    value: setTriggerRef,
                    children: /*#__PURE__*/ (0, $l998X.jsx)($9aa4c7c29923f177$var$IsOpenContext.Provider, {
                        value: isOpen,
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $2xusd.Manager), {
                            children: children
                        })
                    })
                })
            })
        })
    });
};
const $9aa4c7c29923f177$export$95d4acdbab2fc6ef = ({ children: children })=>{
    $9aa4c7c29923f177$var$useEnsureIsInsidePopup();
    const id = (0, $42omo.useContext)($9aa4c7c29923f177$var$IdContext);
    const setTriggerRef = (0, $42omo.useContext)($9aa4c7c29923f177$var$SetTriggerRefContext);
    const isOpen = (0, $42omo.useContext)($9aa4c7c29923f177$var$IsOpenContext);
    const getMergedTriggerRef = (0, $advfQ.useGetMemoizedMergedTriggerRefNew)();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $cs0ez.Reference), {
        children: ({ ref: ref })=>children({
                ref: getMergedTriggerRef(ref, setTriggerRef),
                'aria-controls': id,
                'aria-expanded': isOpen,
                'aria-haspopup': true
            })
    });
};
const $9aa4c7c29923f177$var$defaultLayer = 400;
/**
 * Disables popper.js GPU acceleration for this popup.
 * This means only positioning will be used, without any transforms.
 *
 * Performance will be degraded if the popup is expected to move.
 */ const $9aa4c7c29923f177$var$shouldDisableGpuAccelerationModifiers = [
    {
        name: 'computeStyles',
        options: {
            gpuAcceleration: false
        }
    }
];
const $9aa4c7c29923f177$export$2a2c7ba12d3231e3 = ({ xcss: xcss, appearance: inAppearance = 'default', children: children, boundary: boundary, offset: offset, strategy: strategy, onClose: onClose, testId: testId, rootBoundary: rootBoundary = 'viewport', shouldFlip: shouldFlip = true, placement: placement = 'auto', fallbackPlacements: fallbackPlacements, popupComponent: popupComponent, autoFocus: autoFocus = true, zIndex: zIndex = $9aa4c7c29923f177$var$defaultLayer, shouldUseCaptureOnOutsideClick: shouldUseCaptureOnOutsideClick = false, shouldRenderToParent: inShouldRenderToParent, shouldDisableFocusLock: shouldDisableFocusLock = false, shouldFitContainer: shouldFitContainer, shouldFitViewport: shouldFitViewport, shouldDisableGpuAcceleration: shouldDisableGpuAcceleration = false })=>{
    $9aa4c7c29923f177$var$useEnsureIsInsidePopup();
    const isOpen = (0, $42omo.useContext)($9aa4c7c29923f177$var$IsOpenContext);
    const id = (0, $42omo.useContext)($9aa4c7c29923f177$var$IdContext);
    const triggerRef = (0, $42omo.useContext)($9aa4c7c29923f177$var$TriggerRefContext);
    const { appearance: appearance, shouldRenderToParent: shouldRenderToParent } = (0, $fiAWX.usePopupAppearance)({
        appearance: inAppearance,
        shouldRenderToParent: inShouldRenderToParent
    });
    const handleOpenLayerObserverCloseSignal = (0, $42omo.useCallback)(()=>{
        onClose?.(null);
    }, [
        onClose
    ]);
    (0, $if5rb.useNotifyOpenLayerObserver)({
        isOpen: isOpen,
        onClose: handleOpenLayerObserverCloseSignal
    });
    if (!isOpen) return null;
    const popperWrapper = /*#__PURE__*/ (0, $l998X.jsx)((0, $iug2J.Layering), {
        isDisabled: false,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $2cdko.default), {
            xcss: xcss,
            appearance: appearance,
            content: children,
            isOpen: isOpen,
            placement: placement,
            fallbackPlacements: fallbackPlacements,
            boundary: boundary,
            rootBoundary: rootBoundary,
            shouldFlip: shouldFlip,
            offset: offset,
            popupComponent: popupComponent,
            id: id,
            testId: testId,
            onClose: onClose,
            autoFocus: autoFocus,
            shouldFitContainer: shouldFitContainer,
            shouldUseCaptureOnOutsideClick: shouldUseCaptureOnOutsideClick,
            shouldRenderToParent: shouldRenderToParent,
            shouldDisableFocusLock: shouldDisableFocusLock,
            triggerRef: triggerRef,
            strategy: strategy,
            shouldFitViewport: shouldFitViewport,
            modifiers: shouldDisableGpuAcceleration ? $9aa4c7c29923f177$var$shouldDisableGpuAccelerationModifiers : undefined
        })
    });
    if (shouldRenderToParent) return popperWrapper;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $caX7N.default), {
        zIndex: zIndex,
        children: popperWrapper
    });
};
module.exports["Popup"] = $9aa4c7c29923f177$export$129a32eedafa97c5;
module.exports["PopupTrigger"] = $9aa4c7c29923f177$export$95d4acdbab2fc6ef;
module.exports["PopupContent"] = $9aa4c7c29923f177$export$2a2c7ba12d3231e3;

});

parcelRegister("580cg", function(module, exports) {
/* flyout-menu-item-content.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $3654r = parcelRequire("3654r");


var $dh538 = parcelRequire("dh538");


var $l5LHO = parcelRequire("l5LHO");


var $fFwtP = parcelRequire("fFwtP");

const $1a686eeb6b8b51dd$var$flyoutMenuItemContentStyles = {
    root: "_1q51u2gc _85i5u2gc _bozgu2gc _y4tiu2gc _14b51kdj"
};
const $1a686eeb6b8b51dd$export$2ca9a13c57a8839a = /*#__PURE__*/ (0, $42omo.forwardRef)(({ children: children, containerTestId: containerTestId, onClose: onClose, autoFocus: autoFocus }, forwardedRef)=>{
    const setIsOpen = (0, $42omo.useContext)((0, $fFwtP.SetIsOpenContext));
    const handleClose = (0, $42omo.useCallback)(()=>{
        onClose?.();
        setIsOpen(false);
    }, [
        setIsOpen,
        onClose
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $l5LHO.PopupContent), {
        appearance: "UNSAFE_modal-below-sm",
        onClose: handleClose,
        placement: "right-start",
        // Using a capture event listener so that we are more resilient against
        // code that stops events. We _really_ want to close the flyout whenever
        // user user clicks outside the flyout content
        shouldUseCaptureOnOutsideClick: true,
        shouldFitViewport: true,
        testId: containerTestId,
        xcss: $1a686eeb6b8b51dd$var$flyoutMenuItemContentStyles.root,
        autoFocus: autoFocus,
        /**
   * Disabling GPU acceleration removes the use of `transform` by popper.js for this popup.
   *
   * This allows makers to use popups with `shouldRenderToParent` inside the flyout.
   *
   * Without this, the `transform` makes the flyout the containing element for fixed positioning.
   * Because the flyout is also a scroll container then any nested, layered element is unable to
   * escape the flyout.
   *
   * Disabling the `transform` is the simplest way to resolve this layering issue,
   * and should have negligible performance impacts, because the flyout menus should rarely
   * need to be repositioned.
   */ shouldDisableGpuAcceleration: true,
        shouldRenderToParent: (0, $dh538.fg)('platform_dst_nav4_flyoutmenuitem_render_to_parent'),
        children: ({ update: update })=>/*#__PURE__*/ (0, $l998X.jsx)($1a686eeb6b8b51dd$var$UpdatePopperOnContentResize, {
                ref: forwardedRef,
                update: update,
                children: children
            })
    });
});
function $1a686eeb6b8b51dd$var$createResizeObserver(update) {
    return new ResizeObserver(update);
}
/**
 * Will call the Popper.js `update()` method to recalculate positioning, when the flyout menu changes size.
 * This is the size of the scroll container, NOT the scroll content.
 *
 * We could potentially bake this into `@atlaskit/popup` or `@atlaskit/popper` but there are a few
 * reasons to keep it scoped to flyout menus for now:
 *
 * 1. It's easier to unwind
 * 2. We've only had bug reports for flyout menus
 * 3. Popup exposes the `update` function so consumers can already do this themselves if necessary
 * 4. Flyout menus are a lot more restricted to other popups, it might not make sense more generally
 */ const $1a686eeb6b8b51dd$var$UpdatePopperOnContentResize = /*#__PURE__*/ (0, $42omo.forwardRef)(({ update: update, children: children }, forwardedRef)=>{
    /**
   * Storing our `update` function in a ref so that we have a stable reference to it.
   * We need this because our `ResizeObserver` callback cannot be changed after creating it.
   */ const updateRef = (0, $42omo.useRef)(update);
    (0, $42omo.useEffect)(()=>{
        updateRef.current = update;
    }, [
        update
    ]);
    /**
   * Stable function that calls the latest `update` function by calling it through the stable ref.
   */ const triggerUpdate = (0, $42omo.useCallback)(()=>{
        updateRef.current?.();
    }, []);
    const [resizeObserver] = (0, $42omo.useState)(()=>$1a686eeb6b8b51dd$var$createResizeObserver(triggerUpdate));
    /**
   * This is a callback ref that will update which `HTMLElement` we are observing,
   * if or when the underlying `HTMLElement` changes or unmounts.
   */ const observeCallbackRef = (0, $42omo.useCallback)((element)=>{
        /**
     * Unobserves all observed elements.
     * Allows us to cleanup without needing to store a reference to the previous element.
     */ resizeObserver.disconnect();
        if (!element) return;
        resizeObserver.observe(element);
    }, [
        resizeObserver
    ]);
    /**
   * We need to memoize the ref otherwise `triggerUpdate` is repeatedly called.
   *
   * This stems from ResizeObserver firing once after calling `.observe()` even if there
   * was no resize.
   *
   * Without memoizing the ref, the update causes a rerender, which causes the ref to
   * get recreated, which triggers an update and so on in a loop.
   */ const ref = (0, $42omo.useMemo)(()=>{
        return (0, $3654r.default)([
            forwardedRef,
            observeCallbackRef
        ]);
    }, [
        forwardedRef,
        observeCallbackRef
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        ref: ref,
        children: children
    });
});
module.exports["FlyoutMenuItemContent"] = $1a686eeb6b8b51dd$export$2ca9a13c57a8839a;

});

parcelRegister("f4c6t", function(module, exports) {
/* flyout-menu-item-trigger.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $3654r = parcelRequire("3654r");


var $6R5uz = parcelRequire("6R5uz");


var $l5LHO = parcelRequire("l5LHO");


var $5ujhR = parcelRequire("5ujhR");

const $666e8ec331d0ca1e$var$elemAfterStyles = {
    root: "_18zr12x7 _1tz3r0mg"
};
const $666e8ec331d0ca1e$export$9f59f399fe37b6ca = /*#__PURE__*/ (0, $42omo.forwardRef)(({ children: children, elemBefore: elemBefore, onClick: onClick, isSelected: isSelected, interactionName: interactionName, testId: testId, isContentTooltipDisabled: isContentTooltipDisabled, visualContentRef: visualContentRef, isDragging: isDragging, hasDragIndicator: hasDragIndicator, dropIndicator: dropIndicator }, forwardedRef)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $l5LHO.PopupTrigger), {
        children: ({ ref: ref, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $5ujhR.MenuItemBase), {
                testId: testId,
                ref: (0, $3654r.default)([
                    ref,
                    forwardedRef
                ]),
                visualContentRef: visualContentRef,
                elemBefore: elemBefore,
                elemAfter: /*#__PURE__*/ (0, $l998X.jsx)("div", {
                    className: (0, $gMc0m.default)([
                        $666e8ec331d0ca1e$var$elemAfterStyles.root
                    ]),
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6R5uz))), {
                        label: "",
                        color: "currentColor",
                        size: "small"
                    })
                }),
                onClick: onClick,
                ariaControls: ariaControls,
                ariaExpanded: ariaExpanded,
                ariaHasPopup: ariaHasPopup,
                interactionName: interactionName,
                isContentTooltipDisabled: isContentTooltipDisabled,
                isSelected: isSelected,
                isDragging: isDragging,
                hasDragIndicator: hasDragIndicator,
                dropIndicator: dropIndicator,
                children: children
            })
    }));
module.exports["FlyoutMenuItemTrigger"] = $666e8ec331d0ca1e$export$9f59f399fe37b6ca;

});

parcelRegister("3H0hg", function(module, exports) {

var $kkRaq = parcelRequire("kkRaq");


var $42omo = parcelRequire("42omo");


var $eVdBI = parcelRequire("eVdBI");


var $6IuK2 = parcelRequire("6IuK2");

function $eca3be981a059a11$export$9d7e63760538f47f(item) {
    if (!item || item.type === 'custom' && item.dragPreviewContent) // If the custom item has a drag preview content, we should assume it contains the icon already
    return undefined;
    return item.elemBefore;
}
function $eca3be981a059a11$export$d5d05b25e1604a8f(item, name) {
    if (!item) {
        if (name) return name;
        return undefined;
    }
    if (item.type === 'custom' && item.dragPreviewContent) // Custom items may return their drag preview content as a React node
    return item.dragPreviewContent;
    // If not custom or drag preview content not present, use the label
    return item.labelElem ?? item.label;
}


function $4652fe225d9e3686$export$4696d1da23170d9a({ data: data, item: item, id: id, isExpandable: isExpandable, isItemDraggable: isItemDraggable, isItemDroppable: isItemDroppable, isExpandOrFlyoutOpen: isExpandOrFlyoutOpen, onExpandFlyoutToggle: onExpandFlyoutToggle, isDragAndDropEnabled: isDragAndDropEnabled, group: group, isItemDataInGroup: isItemDataInGroup, isItemData: isItemData, getItemData: getItemData }) {
    const itemIsDraggable = isItemDraggable ? isItemDraggable(data) : !!isDragAndDropEnabled;
    const itemIsDroppable = isItemDroppable ? isItemDroppable(data) : !!isDragAndDropEnabled;
    const { draggableAnchorRef: draggableAnchorRef, draggableButtonRef: draggableButtonRef, state: dragState, dragPreview: dragPreview, dropTargetRef: dropTargetRef, dropIndicator: dropIndicator } = (0, $eVdBI.useMenuItemDragAndDrop)({
        ...isDragAndDropEnabled && {
            ...itemIsDraggable ? {
                draggable: {
                    getInitialData: ()=>getItemData({
                            ...data,
                            menuItemId: id,
                            group: group
                        }),
                    getDragPreviewPieces: ()=>({
                            elemBefore: (0, $eca3be981a059a11$export$9d7e63760538f47f)(item),
                            content: (0, $eca3be981a059a11$export$d5d05b25e1604a8f)(item, data?.label)
                        }),
                    canDrag: ()=>{
                        return isItemDraggable ? isItemDraggable(data) : !!isDragAndDropEnabled;
                    }
                }
            } : {},
            ...itemIsDroppable ? {
                dropTarget: {
                    getData: (args)=>{
                        const { source: source } = args;
                        return getItemData({
                            ...data,
                            menuItemId: id,
                            group: source?.data?.group
                        });
                    },
                    getOperations: ()=>({
                            'reorder-before': itemIsDraggable ? 'available' : undefined,
                            'reorder-after': 'available'
                        }),
                    canDrop: (args)=>{
                        const { source: source } = args;
                        const canDrop = isItemData(source.data) && source.data.menuItemId !== id && isItemDataInGroup(source.data, group);
                        return canDrop;
                    }
                }
            } : {}
        }
    });
    const registry = (0, $6IuK2.useElementRegistry)();
    const registrationRef = (0, $42omo.useRef)(null);
    const draggableRef = (0, $42omo.useCallback)((element)=>{
        if (!element) {
            registrationRef.current?.();
            registrationRef.current = null;
            draggableAnchorRef.current = null;
            draggableButtonRef.current = null;
            return;
        }
        if (element instanceof HTMLAnchorElement) draggableAnchorRef.current = element;
        else draggableButtonRef.current = element;
        if (registrationRef.current) registrationRef.current();
        registrationRef.current = registry.registerL1Item({
            id: id,
            element: element
        });
    }, [
        id,
        registry,
        draggableAnchorRef,
        draggableButtonRef,
        registrationRef
    ]);
    const isDragging = !!itemIsDraggable && dragState.type === 'dragging';
    const expandableClosedForDrag = (0, $42omo.useRef)(false);
    (0, $42omo.useLayoutEffect)(()=>{
        if (!isExpandable || !itemIsDraggable) return;
        if (isDragging && isExpandOrFlyoutOpen) {
            onExpandFlyoutToggle(false);
            expandableClosedForDrag.current = true;
        } else if (!isDragging && expandableClosedForDrag.current) {
            onExpandFlyoutToggle(true);
            expandableClosedForDrag.current = false;
        }
    }, [
        isDragging,
        isExpandable,
        isExpandOrFlyoutOpen,
        itemIsDraggable,
        expandableClosedForDrag,
        onExpandFlyoutToggle
    ]);
    return {
        draggableRef: itemIsDraggable ? draggableRef : undefined,
        isItemDraggable: itemIsDraggable,
        isDragging: isDragging,
        dropTargetRef: itemIsDroppable ? dropTargetRef : undefined,
        dropIndicator: itemIsDroppable ? dropIndicator : undefined,
        maybeDragPreview: itemIsDraggable ? dragPreview : null
    };
}


const $f27439ed9e8d0aff$export$f8cda0f87a8e0691 = ({ item: item, id: id, isExpandable: isExpandable, isExpandOrFlyoutOpen: isExpandOrFlyoutOpen, onExpandFlyoutToggle: onExpandFlyoutToggle, peek: peek, l1DragAndDropEnabled: l1DragAndDropEnabled, group: group })=>{
    const baseData = {
        menuItemId: id,
        group: group,
        isHidden: false,
        isHideable: item.isHideable !== false,
        label: item.label,
        isReorderable: item.isReorderable !== false
    };
    const data = (0, $kkRaq.createL1ItemData)(baseData);
    const isItemDraggable = ()=>{
        return !!l1DragAndDropEnabled && !peek && (item.isHideable !== false || item.isReorderable !== false) && (item.type !== 'custom' || !!item.isDraggable);
    };
    const isItemDroppable = ()=>{
        return !!l1DragAndDropEnabled && !peek && item.type !== 'custom';
    };
    return (0, $4652fe225d9e3686$export$4696d1da23170d9a)({
        data: data,
        item: item,
        id: id,
        isExpandable: isExpandable,
        isExpandOrFlyoutOpen: isExpandOrFlyoutOpen,
        isItemDraggable: isItemDraggable,
        isItemDroppable: isItemDroppable,
        onExpandFlyoutToggle: onExpandFlyoutToggle,
        isDragAndDropEnabled: l1DragAndDropEnabled,
        group: group,
        getItemData: (0, $kkRaq.getL1ItemData),
        isItemData: (0, $kkRaq.isL1ItemData),
        isItemDataInGroup: (0, $kkRaq.isL1ItemDataInGroup)
    });
};
module.exports["useL1ItemDragAndDrop"] = $f27439ed9e8d0aff$export$f8cda0f87a8e0691;

});

parcelRegister("eVdBI", function(module, exports) {
/* use-menu-item-drag-and-drop.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $jTxSS = parcelRequire("jTxSS");


var $dRnqM = parcelRequire("dRnqM");


var $4T4vf = parcelRequire("4T4vf");


var $882hS = parcelRequire("882hS");


var $afUmf = parcelRequire("afUmf");

/* drag-preview.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $dh538 = parcelRequire("dh538");


var $ljmGS = parcelRequire("ljmGS");


var $5ujhR = parcelRequire("5ujhR");


var $kXw3W = parcelRequire("kXw3W");

function $74da737d48c7bec7$var$isSafari() {
    if (typeof window === 'undefined') return false;
    const { userAgent: userAgent } = navigator;
    return userAgent.includes('AppleWebKit') && !userAgent.includes('Chrome');
}
const $74da737d48c7bec7$var$dragPreviewStyles = {
    root: "_2rko12b0 _189ee4h9 _1h6d1l7x _1dqonqa1 _bfhkvuon _y4ti1b66 _p12fgx0z",
    rootT26Shape: "_2rko1qi0",
    safariFix: "_1ul9uuw1"
}; /**
    * A drag preview for sidebar menu items.
    *
    * The limited API corresponds with the limited amount of information we
    * want to show in drag previews.
    *
    * If no `elemBefore` is provided, then the `elemBefore` will automatically collapse.
    * There is no need to pass in `COLLAPSE_ELEM_BEFORE`. We do this as there is no
    * need to maintain vertical side navigation vertical alignment in the drag preview.
    *
    * Please ensure the drag preview is pushed away from the users pointer
    * (with `pointerOutsideOfPreview()` from Pragmatic drag and drop) by our
    * standard amount (`{x: token('space.200'), y: token('space.100')`)
    */ 
function $74da737d48c7bec7$export$905ab40ac2179daa({ elemBefore: elemBefore, children: children }) {
    return(// Resetting the expandable menu items to 0.
    // This is to prevent our hidden element from pushing
    // the drag preview further away from the users pointer
    /*#__PURE__*/ (0, $l998X.jsx)((0, $ljmGS.ExpandableMenuItemLevelContext).Provider, {
        value: 0,
        children: /*#__PURE__*/ (0, $l998X.jsx)("div", {
            className: (0, $gMc0m.default)([
                $74da737d48c7bec7$var$dragPreviewStyles.root,
                (0, $dh538.fg)('platform-dst-shape-theme-default') && $74da737d48c7bec7$var$dragPreviewStyles.rootT26Shape,
                $74da737d48c7bec7$var$isSafari() && $74da737d48c7bec7$var$dragPreviewStyles.safariFix
            ]),
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $5ujhR.MenuItemBase), {
                elemBefore: elemBefore ?? (0, $kXw3W.COLLAPSE_ELEM_BEFORE),
                children: children
            })
        })
    }));
}





parcelRequire("42omo");


var $aTio4 = parcelRequire("aTio4");


var $2n8po = parcelRequire("2n8po");

const $b531d8d12c7f91a5$var$axisLookup = {
    vertical: {
        start: 'top',
        end: 'bottom'
    },
    horizontal: {
        start: 'left',
        end: 'right'
    }
};
function $b531d8d12c7f91a5$export$62ed72bc21f6b8a6({ instruction: instruction, lineGap: lineGap, lineType: lineType }) {
    const appearance = instruction.blocked ? 'warning' : 'default';
    const axis = $b531d8d12c7f91a5$var$axisLookup[instruction.axis];
    if (instruction.operation === 'combine') return /*#__PURE__*/ (0, $l998X.jsx)((0, $aTio4.DropIndicator), {
        appearance: appearance
    });
    if (instruction.operation === 'reorder-before') return /*#__PURE__*/ (0, $l998X.jsx)((0, $2n8po.DropIndicator), {
        edge: axis.start,
        appearance: appearance,
        gap: lineGap,
        type: lineType
    });
    if (instruction.operation === 'reorder-after') return /*#__PURE__*/ (0, $l998X.jsx)((0, $2n8po.DropIndicator), {
        edge: axis.end,
        appearance: appearance,
        gap: lineGap,
        type: lineType
    });
    return null;
}



var $cViGk = parcelRequire("cViGk");

const $1de224db40793572$var$idle = {
    type: 'idle'
};
function $1de224db40793572$export$fe281fdb09fbf0c8({ draggable: draggableArgs, dropTarget: dropTargetArgs }) {
    const draggableAnchorRef = (0, $42omo.useRef)(null);
    const draggableButtonRef = (0, $42omo.useRef)(null);
    const dropTargetRef = (0, $42omo.useRef)(null);
    const [internalState, setInternalState] = (0, $42omo.useState)($1de224db40793572$var$idle);
    const getDraggableElement = (0, $42omo.useCallback)(()=>{
        return draggableAnchorRef.current ?? draggableButtonRef.current ?? null;
    }, []);
    // Set up draggable
    (0, $42omo.useEffect)(()=>{
        // Don't set up a draggable if there are no draggable args
        if (!draggableArgs) return;
        const element = getDraggableElement();
        (0, $dRnqM.default)(element, `draggableAnchorRef or draggableButtonRef not set`);
        return (0, $4T4vf.draggable)({
            element: element,
            getInitialData: draggableArgs.getInitialData,
            canDrag: draggableArgs.canDrag,
            onGenerateDragPreview ({ nativeSetDragImage: nativeSetDragImage, source: source, location: location }) {
                (0, $afUmf.setCustomNativeDragPreview)({
                    nativeSetDragImage: nativeSetDragImage,
                    getOffset: (0, $882hS.pointerOutsideOfPreview)({
                        x: "var(--ds-space-200, 16px)",
                        y: "var(--ds-space-100, 8px)"
                    }),
                    render ({ container: container }) {
                        const args = {
                            dragHandle: source.dragHandle,
                            element: source.element,
                            input: location.current.input
                        };
                        setInternalState({
                            type: 'preview',
                            container: container,
                            ui: draggableArgs.getDragPreviewPieces(args)
                        });
                    }
                });
            },
            onDragStart () {
                setInternalState({
                    type: 'dragging'
                });
            },
            onDrop () {
                setInternalState($1de224db40793572$var$idle);
            }
        });
    }, [
        draggableArgs,
        getDraggableElement
    ]);
    // Set up drop target
    (0, $42omo.useEffect)(()=>{
        if (!dropTargetArgs) return;
        // Don't need to provide a draggable element to have a drop target.
        // Using this element in our `canDrop` check
        const draggableElement = getDraggableElement();
        const dropTarget = dropTargetRef.current;
        (0, $dRnqM.default)(dropTarget, `dropTargetRef was not set`);
        return (0, $4T4vf.dropTargetForElements)({
            element: dropTarget,
            // cannot drop on self
            canDrop: (args)=>{
                // cannot drop on self
                if (args.source.element === draggableElement) return false;
                if (dropTargetArgs.canDrop) return dropTargetArgs.canDrop(args);
                return true;
            },
            // menu items are always sticky, and the GroupDropIndicator should clear stickiness
            getIsSticky: ()=>true,
            getData (args) {
                const data = dropTargetArgs.getData?.(args) ?? {};
                const operations = dropTargetArgs.getOperations(args);
                return (0, $cViGk.attachInstruction)(data, {
                    input: args.input,
                    element: args.element,
                    operations: operations
                });
            },
            onDragStart ({ self: self }) {
                const instruction = (0, $cViGk.extractInstruction)(self.data);
                setInternalState({
                    type: 'is-over',
                    instruction: instruction
                });
            },
            onDrag ({ self: self }) {
                const instruction = (0, $cViGk.extractInstruction)(self.data);
                setInternalState((current)=>{
                    if (current.type === 'is-over' && instruction?.operation === current.instruction?.operation && instruction?.blocked === current.instruction?.blocked) return current;
                    return {
                        type: 'is-over',
                        instruction: instruction
                    };
                });
            },
            onDragLeave () {
                setInternalState($1de224db40793572$var$idle);
            },
            onDrop () {
                setInternalState($1de224db40793572$var$idle);
            },
            onDragEnter ({ self: self }) {
                const instruction = (0, $cViGk.extractInstruction)(self.data);
                setInternalState({
                    type: 'is-over',
                    instruction: instruction
                });
            }
        });
    }, [
        dropTargetArgs,
        getDraggableElement
    ]);
    const dragPreview = (()=>{
        if (internalState.type !== 'preview') return null;
        return /*#__PURE__*/ (0, $jTxSS.createPortal)(/*#__PURE__*/ (0, $l998X.jsx)((0, $74da737d48c7bec7$export$905ab40ac2179daa), {
            elemBefore: internalState.ui.elemBefore,
            children: internalState.ui.content
        }), internalState.container);
    })();
    const dropIndicator = internalState.type === 'is-over' && internalState.instruction && /*#__PURE__*/ (0, $l998X.jsx)((0, $b531d8d12c7f91a5$export$62ed72bc21f6b8a6), {
        instruction: internalState.instruction
    });
    const state = (0, $42omo.useMemo)(()=>{
        if (internalState.type === 'preview') return {
            type: 'preview'
        };
        // returning a new object to avoid modification of our `internalState` object
        return {
            ...internalState
        };
    }, [
        internalState
    ]);
    return {
        state: state,
        draggableButtonRef: draggableButtonRef,
        dropTargetRef: dropTargetRef,
        draggableAnchorRef: draggableAnchorRef,
        dragPreview: dragPreview,
        dropIndicator: dropIndicator
    };
}
module.exports["useMenuItemDragAndDrop"] = $1de224db40793572$export$fe281fdb09fbf0c8;

});

parcelRegister("gasvu", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $7TH2w = parcelRequire("7TH2w");


var $ffCOo = parcelRequire("ffCOo");


var $inPa6 = parcelRequire("inPa6");


var $9kbAI = parcelRequire("9kbAI");


var $dh538 = parcelRequire("dh538");


var $49YLc = parcelRequire("49YLc");


var $eyWa4 = parcelRequire("eyWa4");


var $fwDOR = parcelRequire("fwDOR");


var $hnvzE = parcelRequire("hnvzE");


var $4jETc = parcelRequire("4jETc");

var $caUKj = parcelRequire("caUKj");

var $cmWXZ = parcelRequire("cmWXZ");


var $dBtY8 = parcelRequire("dBtY8");

var $5IDSL = parcelRequire("5IDSL");


var $culkJ = parcelRequire("culkJ");


var $gFauz = parcelRequire("gFauz");




parcelRequire("42omo");


var $keVvA = parcelRequire("keVvA");


var $7FdE1 = parcelRequire("7FdE1");


























const $b8f2a3af0ad05925$export$3770c7a7737d463c = {
    cs: ()=>(parcelRequire("9v0Ka")),
    da: ()=>(parcelRequire("jyJeI")),
    de: ()=>(parcelRequire("judYr")),
    'en-GB': ()=>(parcelRequire("eWFBW")),
    'en-ZZ': ()=>(parcelRequire("fm35k")),
    en: ()=>Promise.resolve((parcelRequire("7FdE1"))),
    es: ()=>(parcelRequire("6iODk")),
    fi: ()=>(parcelRequire("cT0tQ")),
    fr: ()=>(parcelRequire("aaIaE")),
    hu: ()=>(parcelRequire("8vsMB")),
    it: ()=>(parcelRequire("9Tmyz")),
    ja: ()=>(parcelRequire("iKahn")),
    ko: ()=>(parcelRequire("flJ8f")),
    nb: ()=>(parcelRequire("6mqiP")),
    nl: ()=>(parcelRequire("1tQgo")),
    pl: ()=>(parcelRequire("YuzoZ")),
    'pt-BR': ()=>(parcelRequire("3CRlo")),
    ru: ()=>(parcelRequire("3pYOP")),
    sv: ()=>(parcelRequire("8UMOV")),
    th: ()=>(parcelRequire("78H9t")),
    tr: ()=>(parcelRequire("e63Aa")),
    uk: ()=>(parcelRequire("c5u43")),
    vi: ()=>(parcelRequire("gM64v")),
    zh_TW: ()=>(parcelRequire("9kLCb")),
    zh: ()=>(parcelRequire("1TmYN"))
};


const $a5ea78601091ee04$var$fetchMessagesForLocale = async (locale)=>{
    try {
        // Fallback to the generic locale if specified one is not found
        const languageLocale = locale in (0, $b8f2a3af0ad05925$export$3770c7a7737d463c) ? locale : locale.split(/[-_]/)[0] || '';
        // Dynamic import of the locale file
        const localeMessages = await (0, $b8f2a3af0ad05925$export$3770c7a7737d463c)[languageLocale]?.();
        return localeMessages?.default ?? (0, $7FdE1.default);
    } catch (e) {
    // ignore
    }
    return 0, $7FdE1.default;
};
const $a5ea78601091ee04$export$6b89dea1a4334953 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $keVvA.default), {
        defaultMessages: (0, $7FdE1.default),
        loaderFn: $a5ea78601091ee04$var$fetchMessagesForLocale,
        children: children
    });
};


const $0bc646091c24cf0e$export$fe240e33002221f = 'global-shortcuts-platform-component';
const $0bc646091c24cf0e$export$2158b6d23c9689f5 = 'global-shortcuts-data-loading';



var $geKgP = parcelRequire("geKgP");








var $gj7hi = parcelRequire("gj7hi");

const $dc05a67facdb070f$export$8ce0ddc4c9a614d4 = ({ src: src, alt: alt, fallback: fallback, testId: testId })=>{
    const [hasError, setHasError] = (0, $42omo.useState)(false);
    if (!src || hasError) return fallback;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gj7hi.default), {
        src: src,
        alt: alt,
        onError: ()=>{
            setHasError(true);
        },
        testId: testId
    });
};


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");


var $1Whri = parcelRequire("1Whri");


var $6f0Oj = parcelRequire("6f0Oj");

var $bUlM5 = parcelRequire("bUlM5");

var $1GzhS = parcelRequire("1GzhS");


var $kpYGL = parcelRequire("kpYGL");

const $62857df157fde5b7$var$DEFAULT_MENU_SKELETON_HEIGHT = 32;
const $62857df157fde5b7$var$DEFAULT_AVATAR_HEIGHT = 20;
const $62857df157fde5b7$var$DEFAULT_CONTENT_HEIGHT = 12;
const $62857df157fde5b7$var$DEFAULT_BORDER_RADIUS = 4;
const $62857df157fde5b7$var$styles = {
    root: "_4t3izwfg _1bsb1osq _ca0qze3t _n3tdze3t _19bv1b66 _u5f31b66",
    avatar: "_19bvv77o"
};
const $62857df157fde5b7$export$cde35cc9e1359709 = ({ avatarHeight: avatarHeight = $62857df157fde5b7$var$DEFAULT_AVATAR_HEIGHT, contentHeight: contentHeight = $62857df157fde5b7$var$DEFAULT_CONTENT_HEIGHT })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $1GzhS.default), {
        xcss: (0, $1Whri.cx)($62857df157fde5b7$var$styles.root),
        alignBlock: "center",
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $bUlM5.default), {
            alignItems: "center",
            gap: "space.050",
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                    xcss: (0, $1Whri.cx)($62857df157fde5b7$var$styles.avatar),
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $kpYGL.default), {
                        width: avatarHeight,
                        height: avatarHeight,
                        borderRadius: $62857df157fde5b7$var$DEFAULT_BORDER_RADIUS
                    })
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $kpYGL.default), {
                    width: "100%",
                    height: contentHeight,
                    borderRadius: "0"
                })
            ]
        })
    });
};



var $5hYae = parcelRequire("5hYae");




parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $6bJyJ = parcelRequire("6bJyJ");





var $cgtv4 = parcelRequire("cgtv4");

const $0b4de72332c147b6$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    viewAllAppsLabel: {
        id: "navigation.global-shortcuts.view-all-apps.label",
        defaultMessage: "View all apps"
    }
});


function $0b19012007f6ee0e$export$84e063904618ed06({ path: path, isSelected: isSelected, product: product, onNavigate: onNavigate }) {
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const analyticsName = 'VIEW_ALL_APPS';
    if (!path || path.trim().length < 1) return null;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $5hYae.ShortcutMenuItem), {
        shortcut: {
            key: analyticsName,
            analyticsName: analyticsName,
            label: formatMessage((0, $0b4de72332c147b6$export$defe85febe8b728c).viewAllAppsLabel),
            icon: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6bJyJ))), {
                label: ""
            }),
            url: path,
            isReorderable: false,
            type: 'internal',
            isSelected: isSelected,
            onClick: onNavigate
        },
        product: product
    });
}


function $26f372a5788858af$export$bae2da217bf9db6(props) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $hnvzE.default), {
        name: (0, $0bc646091c24cf0e$export$fe240e33002221f),
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $caUKj.BFFProvider), {
            consumer: (0, $4jETc.BFFConsumerEnum).GLOBAL_SHORTCUTS,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $a5ea78601091ee04$export$6b89dea1a4334953), {
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $ffCOo.NavigationAnalyticsContext), {
                    data: {
                        product: props?.product
                    },
                    children: /*#__PURE__*/ (0, $l998X.jsx)($26f372a5788858af$var$Menu, {
                        ...props
                    })
                })
            })
        })
    });
}
function $26f372a5788858af$var$Menu({ testId: testId, shortcutItems: shortcutItems = [], forceStatic: forceStatic, cloudId: cloudId, orgId: orgId, userId: userId, useSkeleton: useSkeleton, promoteSite: promoteSite, productLinksFilter: productLinksFilter, product: product, onUpdateGetFilteredProductLinks: onUpdateGetFilteredProductLinks, enableDragAndDrop: enableDragAndDrop, viewAllAppsConfig: viewAllAppsConfig = {}, openInSameTab: openInSameTab }) {
    // Update Ref
    const onUpdateGetFilteredProductLinksRef = (0, $42omo.useRef)(onUpdateGetFilteredProductLinks);
    onUpdateGetFilteredProductLinksRef.current = onUpdateGetFilteredProductLinks;
    // Filter Ref
    const productLinksFilterRef = (0, $42omo.useRef)(productLinksFilter);
    productLinksFilterRef.current = productLinksFilter;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { handleError: handleError } = $26f372a5788858af$var$useConditionalNavBoundaryContext({
        location: (0, $dBtY8.ERROR_LOCATION__GLOBAL_SHORTCUTS),
        sentryConfig: {
            product: product
        }
    });
    const { buildURLAndFetchData: buildURLAndFetchData, status: status, error: error, productLinks: productLinks } = (0, $cmWXZ.useBFFDataProvider)({
        request: {},
        cloudId: cloudId,
        orgId: orgId,
        userId: userId,
        forceStatic: forceStatic,
        product: product
    });
    /**
   * Making a stable reference to `productLinks` to avoid `getFilteredProductLinks`
   * changing and calling `onUpdateGetFilteredProductLinksRef` repeatedly.
   */ const productLinksRef = (0, $42omo.useRef)(productLinks);
    (0, $42omo.useEffect)(()=>{
        productLinksRef.current = productLinks;
    }, [
        productLinks
    ]);
    const getFilteredProductLinksOld = (0, $42omo.useCallback)((apsKey)=>{
        let filteredProductLinks = productLinks[apsKey] ?? [];
        if (productLinksFilterRef.current) filteredProductLinks = filteredProductLinks.filter(productLinksFilterRef.current);
        return {
            promotedLink: filteredProductLinks.find((item, _i, arr)=>arr.length === 1 || promoteSite && item.isCurrentSite),
            links: filteredProductLinks.filter((item, _i, arr)=>arr.length === 1 || !(promoteSite && item.isCurrentSite)),
            status: status
        };
    }, [
        productLinks,
        promoteSite,
        status
    ]);
    const getFilteredProductLinksNew = (0, $42omo.useCallback)((apsKey)=>{
        let filteredProductLinks = productLinksRef.current[apsKey] ?? [];
        if (productLinksFilterRef.current) filteredProductLinks = filteredProductLinks.filter(productLinksFilterRef.current);
        return {
            promotedLink: filteredProductLinks.find((item, _i, arr)=>arr.length === 1 || promoteSite && item.isCurrentSite),
            links: filteredProductLinks.filter((item, _i, arr)=>arr.length === 1 || !(promoteSite && item.isCurrentSite)),
            status: status
        };
    }, [
        promoteSite,
        status
    ]);
    const getFilteredProductLinks = (0, $dh538.fg)('navx-2972_fix_fhs_locking_problems') ? getFilteredProductLinksNew : getFilteredProductLinksOld;
    const mappedShortcutItems = (0, $42omo.useMemo)(()=>{
        return shortcutItems.map((item, index)=>{
            const key = item.type === 'link' && item.apsKey || `shortcut-${index}`;
            // Render nested items if the dynamic data is available and we are not forcing static rendering
            if (!forceStatic && status?.toLowerCase() === (0, $4jETc.RequestStatus).COMPLETE && item.type === 'link' && item.apsKey && productLinks?.[item.apsKey]) {
                const { links: filteredProductLinks, promotedLink: promotedLink } = getFilteredProductLinks(item.apsKey);
                const siteName = filteredProductLinks?.[0]?.displayName;
                // Determine whether shortcut is a single site and is current site and return link instead of flyout
                if (filteredProductLinks.length === 1 && !item.url) return {
                    ...item,
                    key: key,
                    url: filteredProductLinks[0].url
                };
                if (filteredProductLinks.length > 1) return {
                    ...item,
                    siteName: siteName,
                    key: key,
                    type: 'expand',
                    promoted: promotedLink ? {
                        type: 'link',
                        icon: /*#__PURE__*/ (0, $l998X.jsx)((0, $dc05a67facdb070f$export$8ce0ddc4c9a614d4), {
                            src: promotedLink.avatar,
                            alt: "",
                            fallback: item.icon
                        }),
                        label: promotedLink.displayName,
                        url: promotedLink.url
                    } : undefined,
                    items: filteredProductLinks.map((link)=>({
                            type: 'link',
                            icon: /*#__PURE__*/ (0, $l998X.jsx)((0, $dc05a67facdb070f$export$8ce0ddc4c9a614d4), {
                                src: link.avatar,
                                alt: "",
                                fallback: item.icon
                            }),
                            label: link.displayName,
                            displayName: link.displayName,
                            url: link.url
                        }))
                };
            }
            return {
                ...item,
                key: key
            };
        });
    }, [
        shortcutItems,
        productLinks,
        forceStatic,
        status,
        getFilteredProductLinks
    ]);
    (0, $42omo.useEffect)(()=>{
        if (onUpdateGetFilteredProductLinksRef.current) onUpdateGetFilteredProductLinksRef.current(getFilteredProductLinks);
    }, [
        getFilteredProductLinks
    ]);
    (0, $42omo.useEffect)(()=>{
        if (status === (0, $4jETc.RequestStatus).ERROR && error) handleError(error, {
            componentStack: 'Menu'
        });
    }, [
        status,
        handleError,
        error
    ]);
    const apsKeys = (0, $42omo.useMemo)(()=>{
        return shortcutItems.map((item)=>item.type === 'link' && item.apsKey || '').filter((item)=>!!item);
    }, [
        shortcutItems
    ]);
    const mountedRef = (0, $42omo.useRef)(false);
    (0, $42omo.useEffect)(()=>{
        if (forceStatic || status?.toLowerCase() !== (0, $4jETc.RequestStatus).COMPLETE || productLinks && !Object.keys(productLinks).length || mountedRef.current === true) return;
        mountedRef.current = true;
        const missingShortcuts = shortcutItems.filter((item)=>item.type === 'link').filter((item)=>{
            // todo: Should we also include links with missing APS keys? Currently a link could be missing an APS key and not be included in this list.
            return !(0, $gFauz.getUrlMaybe)(item) && item.apsKey && !productLinks?.[item.apsKey];
        });
        const intended = shortcutItems.length;
        const rendered = intended - missingShortcuts.length;
        createAnalyticsEvent({
            eventType: (0, $7TH2w.UI_EVENT_TYPE),
            action: 'cls',
            actionSubject: 'menu',
            actionSubjectId: 'globalNavigation',
            attributes: {
                name: product,
                intended: intended,
                rendered: rendered,
                missingAPSKeys: missingShortcuts.map((item)=>item.apsKey).filter(Boolean)
            }
        }).fire((0, $culkJ.ANALYTICS_CHANNEL));
    }, [
        createAnalyticsEvent,
        shortcutItems,
        productLinks,
        product,
        forceStatic,
        status
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!forceStatic) buildURLAndFetchData();
    }, [
        apsKeys,
        buildURLAndFetchData,
        forceStatic
    ]);
    const createLinkItem = (0, $42omo.useCallback)((shortcut)=>{
        if (status?.toLowerCase() === (0, $4jETc.RequestStatus).COMPLETE) return /*#__PURE__*/ (0, $l998X.jsx)((0, $5hYae.ShortcutMenuItem), {
            shortcut: shortcut,
            openInSameTab: openInSameTab,
            status: status,
            expandItems: shortcut.type === 'expand' && (shortcut.items?.length ?? false) ? shortcut.items : undefined,
            promotedItem: shortcut.type === 'expand' ? shortcut.promoted : undefined,
            siteName: shortcut.type === 'expand' ? shortcut.siteName : undefined,
            product: product
        }, shortcut.key);
        // Show skeleton while BFF is loading
        if (useSkeleton && (status === (0, $4jETc.RequestStatus).LOADING || status === (0, $4jETc.RequestStatus).INIT)) return /*#__PURE__*/ (0, $l998X.jsx)((0, $62857df157fde5b7$export$cde35cc9e1359709), {}, shortcut.key);
        // We only want to allow static menu expand item if we are forcing static,
        // otherwise it should be showing the singular item as a disabled link until the
        // data is loaded.
        if (forceStatic && shortcut.type === 'expand' && shortcut.items) return /*#__PURE__*/ (0, $l998X.jsx)((0, $5hYae.ShortcutMenuItem), {
            shortcut: shortcut,
            expandItems: shortcut.items,
            forceStatic: forceStatic,
            product: product,
            openInSameTab: openInSameTab
        }, shortcut.key);
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $5hYae.ShortcutMenuItem), {
            shortcut: shortcut,
            status: status,
            forceStatic: forceStatic,
            product: product,
            openInSameTab: openInSameTab
        }, shortcut.key);
    }, [
        forceStatic,
        product,
        status,
        useSkeleton,
        openInSameTab
    ]);
    const shortcutList = /*#__PURE__*/ (0, $l998X.jsxs)((0, $9kbAI.MenuList), {
        children: [
            mappedShortcutItems?.map(createLinkItem),
            viewAllAppsConfig?.path && (0, $dh538.fg)('navx-1065-global-shortcuts-view-all-apps') && /*#__PURE__*/ (0, $l998X.jsx)((0, $0b19012007f6ee0e$export$84e063904618ed06), {
                ...viewAllAppsConfig,
                product: product
            })
        ]
    });
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
        testId: testId,
        children: [
            enableDragAndDrop ? /*#__PURE__*/ (0, $l998X.jsx)((0, $geKgP.DragAndDropOptionsProvider), {
                enabled: enableDragAndDrop,
                children: shortcutList
            }) : shortcutList,
            !forceStatic && /*#__PURE__*/ (0, $l998X.jsx)((0, $fwDOR.default), {
                name: (0, $0bc646091c24cf0e$export$2158b6d23c9689f5),
                hold: status === (0, $4jETc.RequestStatus).INIT || status === (0, $4jETc.RequestStatus).LOADING
            })
        ]
    });
}
const $26f372a5788858af$var$useConditionalNavBoundaryContext = (0, $49YLc.functionWithFG)('navx-1574-navigation-error-boundary-shortcuts', (0, $5IDSL.useNavBoundaryContext), ()=>({
        handleError: ()=>{}
    }));
module.exports["GlobalShortcuts"] = $26f372a5788858af$export$bae2da217bf9db6;

});

parcelRegister("culkJ", function(module, exports) {
/**
 * Product keys as defined in flight-deck.
 * https://bitbucket.org/atlassian/flight-deck/src/master/packages/integrations/twp-switch-to-products/contrib/
 */ var $062f3565ea2f6981$export$92e44ea1079b9ec6 = /*#__PURE__*/ function(Products) {
    // ATLAS_* - Need to be standalone apps to sit in this space
    Products["ATLAS_ALIGN"] = "ALIGN";
    Products["ATLAS_HOME"] = "ATLAS_HOME";
    Products["ATLAS_GOALS"] = "GOALS";
    Products["ATLAS_TEAMS"] = "TEAMS";
    Products["ATLAS_HUB"] = "ATLAS_HUB";
    Products["ANALYTICS"] = "ANALYTICS";
    Products["ASSETS"] = "ASSETS";
    Products["BITBUCKET"] = "BITBUCKET";
    Products["COMPASS"] = "COMPASS";
    Products["CUSTOMER_SERVICE_MANAGEMENT"] = "JIRA_CUSTOMER_SERVICE";
    Products["FOCUS"] = "mercury";
    Products["STUDIO"] = "STUDIO";
    Products["OPSGENIE"] = "OPSGENIE";
    Products["JIRA_SERVICE_MANAGEMENT"] = "JIRA_SERVICE_DESK";
    Products["JIRA_PRODUCT_DISCOVERY"] = "JIRA_PRODUCT_DISCOVERY";
    Products["JIRA_SOFTWARE"] = "JIRA_SOFTWARE";
    Products["CONFLUENCE"] = "CONFLUENCE";
    Products["LOOM"] = "LOOM";
    Products["PROJECTS"] = "PROJECTS";
    Products["TALENT"] = "TALENT";
    Products["TRELLO"] = "TRELLO";
    return Products;
}({});
const $062f3565ea2f6981$export$85183a312807388d = 'navigation';
module.exports["Products"] = $062f3565ea2f6981$export$92e44ea1079b9ec6;
module.exports["ANALYTICS_CHANNEL"] = $062f3565ea2f6981$export$85183a312807388d;

});

parcelRegister("gFauz", function(module, exports) {

var $kVqQ6 = parcelRequire("kVqQ6");

const $46397dd2e0c2b3dd$export$ac51fdc0c7ed862d = (options)=>options.url || (0, $kVqQ6.getFallbackUrlMaybe)(options.fallbackUrl);
module.exports["getUrlMaybe"] = $46397dd2e0c2b3dd$export$ac51fdc0c7ed862d;

});

parcelRegister("7FdE1", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $a39680e968b16aaa$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $4yBJM = parcelRequire("4yBJM");

var $a39680e968b16aaa$export$2e2bcd8739ae039 = (0, $4yBJM.default);

});

parcelRegister("9v0Ka", function(module, exports) {

let $6ea795ffe93e95cc$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $6ea795ffe93e95cc$var$load("1jsQH"),
    $6ea795ffe93e95cc$var$load("bv8GZ"),
    $6ea795ffe93e95cc$var$load("i5eMd"),
    $6ea795ffe93e95cc$var$load("4DYJ5"),
    $6ea795ffe93e95cc$var$load("gyXEE"),
    $6ea795ffe93e95cc$var$load("hoPZ9")
]).then(()=>parcelRequire('br2f9'));

});

parcelRegister("4mJKd", function(module, exports) {
"use strict";


let $32dcb3648bfd454e$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("8tirZ")).shardUrl((parcelRequire("02nRr")).resolve(id), maxShards));
    };
module.exports = $32dcb3648bfd454e$var$load;

});

parcelRegister("8tirZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $62af5803f3d08114$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $62af5803f3d08114$var$getDomainShardIndex;
module.exports.shardUrl = $62af5803f3d08114$var$shardUrl;
module.exports.shardUrlUnchecked = $62af5803f3d08114$var$shardUrlUnchecked;
const $62af5803f3d08114$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $62af5803f3d08114$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $62af5803f3d08114$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $62af5803f3d08114$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $62af5803f3d08114$var$removeTrailingShard(subdomain) {
    if (!$62af5803f3d08114$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $62af5803f3d08114$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$62af5803f3d08114$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $62af5803f3d08114$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $62af5803f3d08114$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $62af5803f3d08114$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $62af5803f3d08114$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $62af5803f3d08114$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$62af5803f3d08114$var$globalKeyName]) return url;
    return $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards);
}
const $62af5803f3d08114$var$domainShardingKey = module.exports.domainShardingKey = $62af5803f3d08114$var$globalKeyName;

});

parcelRegister("02nRr", function(module, exports) {
$parcel$export(module.exports, "register", () => $0072b2502976b004$export$6503ec6e8aabbaf, (v) => $0072b2502976b004$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0072b2502976b004$export$f7ad0328861e2f03, (v) => $0072b2502976b004$export$f7ad0328861e2f03 = v);
var $0072b2502976b004$export$6503ec6e8aabbaf;
var $0072b2502976b004$export$f7ad0328861e2f03;
"use strict";
var $0072b2502976b004$var$mapping = new Map();
function $0072b2502976b004$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0072b2502976b004$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0072b2502976b004$var$resolve(id) {
    var resolved = $0072b2502976b004$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0072b2502976b004$export$6503ec6e8aabbaf = $0072b2502976b004$var$register;
$0072b2502976b004$export$f7ad0328861e2f03 = $0072b2502976b004$var$resolve;

});

parcelRegister("jyJeI", function(module, exports) {

let $e3d44847340b13e8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $e3d44847340b13e8$var$load("deyvi"),
    $e3d44847340b13e8$var$load("cdeuH"),
    $e3d44847340b13e8$var$load("4UPfH"),
    $e3d44847340b13e8$var$load("hfFxJ"),
    $e3d44847340b13e8$var$load("1Mp9N"),
    $e3d44847340b13e8$var$load("2Fu3d")
]).then(()=>parcelRequire('5T7BQ'));

});

parcelRegister("judYr", function(module, exports) {

let $e2fba8918f14da6f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $e2fba8918f14da6f$var$load("6dERU"),
    $e2fba8918f14da6f$var$load("7gF8f"),
    $e2fba8918f14da6f$var$load("gd4qs"),
    $e2fba8918f14da6f$var$load("gofGr"),
    $e2fba8918f14da6f$var$load("dBb6q"),
    $e2fba8918f14da6f$var$load("eJgH8")
]).then(()=>parcelRequire('f72Ys'));

});

parcelRegister("eWFBW", function(module, exports) {

let $ae16c285e4f9d202$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $ae16c285e4f9d202$var$load("aSjrK"),
    $ae16c285e4f9d202$var$load("03aeW")
]).then(()=>parcelRequire('9Uzok'));

});

parcelRegister("fm35k", function(module, exports) {

let $b2db4db2ad0492af$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $b2db4db2ad0492af$var$load("j0PWv"),
    $b2db4db2ad0492af$var$load("ksTQ6"),
    $b2db4db2ad0492af$var$load("eBoC7"),
    $b2db4db2ad0492af$var$load("7NpX8"),
    $b2db4db2ad0492af$var$load("cukQS"),
    $b2db4db2ad0492af$var$load("5FaEJ")
]).then(()=>parcelRequire('hFCKc'));

});

parcelRegister("6iODk", function(module, exports) {

let $496bb33f5c6d6888$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $496bb33f5c6d6888$var$load("dlmud"),
    $496bb33f5c6d6888$var$load("5CGnz"),
    $496bb33f5c6d6888$var$load("bNv64"),
    $496bb33f5c6d6888$var$load("bFU3Y"),
    $496bb33f5c6d6888$var$load("3CucM"),
    $496bb33f5c6d6888$var$load("9yemY")
]).then(()=>parcelRequire('kosLT'));

});

parcelRegister("cT0tQ", function(module, exports) {

let $961afe7e66c49aff$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $961afe7e66c49aff$var$load("cbkj0"),
    $961afe7e66c49aff$var$load("9Oxgj"),
    $961afe7e66c49aff$var$load("4Afgd"),
    $961afe7e66c49aff$var$load("exaJ2"),
    $961afe7e66c49aff$var$load("lp8Wm"),
    $961afe7e66c49aff$var$load("l2LZP")
]).then(()=>parcelRequire('ggDJR'));

});

parcelRegister("aaIaE", function(module, exports) {

let $767d19f565851926$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $767d19f565851926$var$load("17m16"),
    $767d19f565851926$var$load("kAg8V"),
    $767d19f565851926$var$load("cMubu"),
    $767d19f565851926$var$load("hcCcg"),
    $767d19f565851926$var$load("cHWSM"),
    $767d19f565851926$var$load("35Ssm")
]).then(()=>parcelRequire('4f1t8'));

});

parcelRegister("8vsMB", function(module, exports) {

let $01992769e0cba8af$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $01992769e0cba8af$var$load("b4NO6"),
    $01992769e0cba8af$var$load("fM2oh"),
    $01992769e0cba8af$var$load("3fLE9"),
    $01992769e0cba8af$var$load("j9KTb"),
    $01992769e0cba8af$var$load("b37xN"),
    $01992769e0cba8af$var$load("ik6u5")
]).then(()=>parcelRequire('3xm6B'));

});

parcelRegister("9Tmyz", function(module, exports) {

let $733abf5c0e558ab6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $733abf5c0e558ab6$var$load("1K1Fj"),
    $733abf5c0e558ab6$var$load("xnqy2"),
    $733abf5c0e558ab6$var$load("8hOn0"),
    $733abf5c0e558ab6$var$load("3hjAq"),
    $733abf5c0e558ab6$var$load("7PjNK"),
    $733abf5c0e558ab6$var$load("Vt6S9")
]).then(()=>parcelRequire('abc2w'));

});

parcelRegister("iKahn", function(module, exports) {

let $da547f2451d2cd49$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $da547f2451d2cd49$var$load("38sfA"),
    $da547f2451d2cd49$var$load("awkVi"),
    $da547f2451d2cd49$var$load("h4OCL"),
    $da547f2451d2cd49$var$load("2bCHJ"),
    $da547f2451d2cd49$var$load("ktSfi"),
    $da547f2451d2cd49$var$load("9GZ76")
]).then(()=>parcelRequire('iOsEl'));

});

parcelRegister("flJ8f", function(module, exports) {

let $b2cbd3710de23937$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $b2cbd3710de23937$var$load("bjmre"),
    $b2cbd3710de23937$var$load("11DLa"),
    $b2cbd3710de23937$var$load("bcQs2"),
    $b2cbd3710de23937$var$load("fdXnq"),
    $b2cbd3710de23937$var$load("iouLY"),
    $b2cbd3710de23937$var$load("4sOIV")
]).then(()=>parcelRequire('aIqdH'));

});

parcelRegister("6mqiP", function(module, exports) {

let $4a1933501e611a4f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $4a1933501e611a4f$var$load("asvK9"),
    $4a1933501e611a4f$var$load("barSq"),
    $4a1933501e611a4f$var$load("aBa7j"),
    $4a1933501e611a4f$var$load("cItJR"),
    $4a1933501e611a4f$var$load("hPZE5"),
    $4a1933501e611a4f$var$load("QTjdE")
]).then(()=>parcelRequire('6B9u2'));

});

parcelRegister("1tQgo", function(module, exports) {

let $11410a49435bf279$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $11410a49435bf279$var$load("7v6wU"),
    $11410a49435bf279$var$load("a8heY"),
    $11410a49435bf279$var$load("b544F"),
    $11410a49435bf279$var$load("SctKm"),
    $11410a49435bf279$var$load("dzIm8"),
    $11410a49435bf279$var$load("hrf1M")
]).then(()=>parcelRequire('bZefw'));

});

parcelRegister("YuzoZ", function(module, exports) {

let $0b5d5146e6e1dd26$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $0b5d5146e6e1dd26$var$load("aEpRh"),
    $0b5d5146e6e1dd26$var$load("6hlNE"),
    $0b5d5146e6e1dd26$var$load("K6fhx"),
    $0b5d5146e6e1dd26$var$load("1fJz1"),
    $0b5d5146e6e1dd26$var$load("jqwnR"),
    $0b5d5146e6e1dd26$var$load("lsloj")
]).then(()=>parcelRequire('kzj9p'));

});

parcelRegister("3CRlo", function(module, exports) {

let $2a3e4cb75fdb2a6f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $2a3e4cb75fdb2a6f$var$load("3fuR9"),
    $2a3e4cb75fdb2a6f$var$load("2bqSD"),
    $2a3e4cb75fdb2a6f$var$load("gZU54"),
    $2a3e4cb75fdb2a6f$var$load("9yA8o"),
    $2a3e4cb75fdb2a6f$var$load("bGhLc"),
    $2a3e4cb75fdb2a6f$var$load("iRKhU")
]).then(()=>parcelRequire('5JjoD'));

});

parcelRegister("3pYOP", function(module, exports) {

let $27d2e23f85a9440b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $27d2e23f85a9440b$var$load("fMrUo"),
    $27d2e23f85a9440b$var$load("bJykp"),
    $27d2e23f85a9440b$var$load("4Wdqb"),
    $27d2e23f85a9440b$var$load("448N7"),
    $27d2e23f85a9440b$var$load("9v6ER"),
    $27d2e23f85a9440b$var$load("aEAsN")
]).then(()=>parcelRequire('kJ9vR'));

});

parcelRegister("8UMOV", function(module, exports) {

let $67d96c612d283de9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $67d96c612d283de9$var$load("9eNkX"),
    $67d96c612d283de9$var$load("dh2Er"),
    $67d96c612d283de9$var$load("k10Cs"),
    $67d96c612d283de9$var$load("gBDdh"),
    $67d96c612d283de9$var$load("8Mz40"),
    $67d96c612d283de9$var$load("l6YHr")
]).then(()=>parcelRequire('vKazA'));

});

parcelRegister("78H9t", function(module, exports) {

let $532ac0d0a30e5dbf$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $532ac0d0a30e5dbf$var$load("fdczG"),
    $532ac0d0a30e5dbf$var$load("6nK39")
]).then(()=>parcelRequire('3GtCy'));

});

parcelRegister("e63Aa", function(module, exports) {

let $a43467985c6d32a2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $a43467985c6d32a2$var$load("epkdv"),
    $a43467985c6d32a2$var$load("hWNfo")
]).then(()=>parcelRequire('72BhT'));

});

parcelRegister("c5u43", function(module, exports) {

let $8ccd45d65bf67c8e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $8ccd45d65bf67c8e$var$load("3MGOs"),
    $8ccd45d65bf67c8e$var$load("8UuQQ")
]).then(()=>parcelRequire('6yNb3'));

});

parcelRegister("gM64v", function(module, exports) {

let $c365d6c2c8c7b614$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $c365d6c2c8c7b614$var$load("innCz"),
    $c365d6c2c8c7b614$var$load("6BkMx")
]).then(()=>parcelRequire('74VfG'));

});

parcelRegister("9kLCb", function(module, exports) {

let $6cbaeaa163a68c8d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $6cbaeaa163a68c8d$var$load("j9OUx"),
    $6cbaeaa163a68c8d$var$load("bV8sS"),
    $6cbaeaa163a68c8d$var$load("l079e"),
    $6cbaeaa163a68c8d$var$load("ebljE"),
    $6cbaeaa163a68c8d$var$load("hF4v3"),
    $6cbaeaa163a68c8d$var$load("afU9w")
]).then(()=>parcelRequire('hP4wC'));

});

parcelRegister("1TmYN", function(module, exports) {

let $160cc0c9eaaee08f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $160cc0c9eaaee08f$var$load("gDiIK"),
    $160cc0c9eaaee08f$var$load("eLlpV"),
    $160cc0c9eaaee08f$var$load("f1B4n"),
    $160cc0c9eaaee08f$var$load("j4dSZ"),
    $160cc0c9eaaee08f$var$load("1Tuyb"),
    $160cc0c9eaaee08f$var$load("7iCpI")
]).then(()=>parcelRequire('hc8vA'));

});

parcelRegister("5hYae", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $7TH2w = parcelRequire("7TH2w");


var $inPa6 = parcelRequire("inPa6");


var $bedQP = parcelRequire("bedQP");


var $4jETc = parcelRequire("4jETc");


var $dBtY8 = parcelRequire("dBtY8");

var $5xxOu = parcelRequire("5xxOu");


var $culkJ = parcelRequire("culkJ");


var $kVqQ6 = parcelRequire("kVqQ6");


var $gFauz = parcelRequire("gFauz");

/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 















var $ccHMk = parcelRequire("ccHMk");


var $1Whri = parcelRequire("1Whri");


var $3654r = parcelRequire("3654r");


var $iI2ST = parcelRequire("iI2ST");


var $h0OZ6 = parcelRequire("h0OZ6");

var $580cg = parcelRequire("580cg");

var $f4c6t = parcelRequire("f4c6t");


var $9kbAI = parcelRequire("9kbAI");


var $gdv5Z = parcelRequire("gdv5Z");







/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");








var $7hXDW = parcelRequire("7hXDW");


var $Rk8D3 = parcelRequire("Rk8D3");

var $6f0Oj = parcelRequire("6f0Oj");


var $cgtv4 = parcelRequire("cgtv4");

const $f599cee8bd06af11$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    sites: {
        id: "navigation.global-shortcuts.sites",
        defaultMessage: "{productName} sites"
    }
});


const $8a78adbc066f498f$var$styles = {
    root: "_1e0c1txw _2lx21bp4 _c71l1x4w _18m91wug _19bvu2gc _u5f3u2gc",
    heading: "_1rjc12x7 _19bv12x7 _1e0c1txw _4cvr1h6o"
};
const $8a78adbc066f498f$export$479f0f2f71193efe = ({ children: children, heading: heading })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $Rk8D3.default), {
        xcss: (0, $1Whri.cx)($8a78adbc066f498f$var$styles.root),
        inline: "space.100",
        children: [
            heading && /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                xcss: (0, $1Whri.cx)($8a78adbc066f498f$var$styles.heading),
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $7hXDW.default), {
                    size: "xsmall",
                    as: "h2",
                    children: formatMessage((0, $f599cee8bd06af11$export$defe85febe8b728c).sites, {
                        productName: heading
                    })
                })
            }),
            children
        ]
    });
};


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 






var $39XmP = parcelRequire("39XmP");

















var $8tdj3 = parcelRequire("8tdj3");





var $lujnM = parcelRequire("lujnM");


var $dh538 = parcelRequire("dh538");





var $fdzcy = parcelRequire("fdzcy");


var $3H0hg = parcelRequire("3H0hg");











var $fFa3V = parcelRequire("fFa3V");




const $5b328a77149103a7$var$ElementEventListenerDeprecated = ({ handler: handler, children: children })=>{
    const wrapperRef = (0, $42omo.useRef)(null);
    (0, $42omo.useEffect)(()=>{
        if (!wrapperRef.current || !handler) return;
        const handleMouseDown = (e)=>{
            const isLink = e.target.closest('a');
            if (isLink && e.button !== 0) handler();
        };
        const unbind = (0, $fFa3V.bind)(wrapperRef.current, {
            type: 'mousedown',
            listener: handleMouseDown
        });
        return unbind;
    }, [
        handler
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)("span", {
        ref: wrapperRef,
        children: children
    });
};
const $5b328a77149103a7$var$ElementEventListenerUpdated = ({ onFocus: onFocus, onMouseEnter: onMouseEnter, onRightClick: onRightClick, children: children })=>{
    const wrapperRef = (0, $42omo.useRef)(null);
    (0, $42omo.useEffect)(()=>{
        if (!wrapperRef.current || !onRightClick) return;
        const handleMouseDown = (e)=>{
            const isLink = e.target.closest('a');
            if (isLink && e.button !== 0) onRightClick();
        };
        const unbind = (0, $fFa3V.bind)(wrapperRef.current, {
            type: 'mousedown',
            listener: handleMouseDown
        });
        return unbind;
    }, [
        onRightClick
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)("span", {
        ref: wrapperRef,
        onMouseEnter: onMouseEnter,
        onFocus: onFocus,
        children: children
    });
};
const $5b328a77149103a7$export$8209b3c2d1620841 = (0, $bedQP.componentWithFG)('teams-shortcut-next-confluence', $5b328a77149103a7$var$ElementEventListenerUpdated, $5b328a77149103a7$var$ElementEventListenerDeprecated);






var $geKgP = parcelRequire("geKgP");

const $dd4485e00eedab96$export$eae7963fc47ca0d0 = ()=>{
    const context = (0, $42omo.useContext)((0, $geKgP.DragAndDropOptionsContext));
    if (!context) return {
        enabled: false
    };
    return {
        enabled: context.enabled
    };
};


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");

















var $9hlns = parcelRequire("9hlns");




const $120bf42293d1fba3$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    loadingItemAriaLabel: {
        id: "navigation.global-shortcuts.menu-loading-item.loading-item-aria-label",
        defaultMessage: "(loading)"
    }
});


const $c9a9a1032b23ec6d$var$styles = {
    iconsBlock: "_18zr12x7"
};
const $c9a9a1032b23ec6d$export$6c62e509491f8f00 = ({ icon: icon, label: label, showLinkIcon: showLinkIcon })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $iI2ST.ButtonMenuItem), {
        elemBefore: icon,
        elemAfter: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
            xcss: (0, $1Whri.cx)($c9a9a1032b23ec6d$var$styles.iconsBlock),
            children: showLinkIcon ? /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8tdj3))), {
                label: formatMessage((0, $120bf42293d1fba3$export$defe85febe8b728c).loadingItemAriaLabel),
                size: "small"
            }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $9hlns.default), {
                size: "small"
            })
        }),
        testId: "menu-button-loading",
        children: [
            label,
            /*#__PURE__*/ (0, $l998X.jsx)("span", {
                "aria-label": formatMessage((0, $120bf42293d1fba3$export$defe85febe8b728c).loadingItemAriaLabel)
            })
        ]
    });
};


















var $1qfLF = parcelRequire("1qfLF");


var $g5gZt = parcelRequire("g5gZt");


var $56M4r = parcelRequire("56M4r");

var $2SlZp = parcelRequire("2SlZp");





var $lGgRw = parcelRequire("lGgRw");







const $bae1ab3d84e6d86e$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    shortcutActionOpenMenuLabel: {
        id: "navigation.global-shortcuts.shortcut-action.open-menu-label",
        defaultMessage: "open menu"
    }
});


const $d6eb3e10d21d0abb$var$fireShortcutActionMenuClickedAnalyticsEvent = (createAnalyticsEvent, analyticsName)=>{
    createAnalyticsEvent({
        eventType: (0, $7TH2w.UI_EVENT_TYPE),
        action: 'clicked',
        actionSubject: 'button',
        actionSubjectId: 'ShortcutActionMenu',
        attributes: {
            name: analyticsName
        }
    }).fire((0, $culkJ.ANALYTICS_CHANNEL));
};
const $d6eb3e10d21d0abb$var$ShortcutActionMenuDeprecated = ({ actions: actions })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [isOpen, setIsOpen] = (0, $42omo.useState)(false);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $lGgRw.Popup), {
        shouldRenderToParent: true,
        isOpen: isOpen,
        onClose: ()=>setIsOpen(false),
        placement: "bottom-start",
        content: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $2SlZp.default), {
                children: actions.map((action, index)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $56M4r.default), {
                        onClick: (e)=>{
                            e.preventDefault();
                            action.onClick?.();
                            setIsOpen(false);
                        },
                        children: action.component
                    }, index))
            }),
        trigger: (triggerProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                ...triggerProps,
                appearance: "subtle",
                spacing: "compact",
                icon: (props)=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($g5gZt))), {
                        ...props,
                        size: "small"
                    }),
                label: formatMessage((0, $bae1ab3d84e6d86e$export$defe85febe8b728c).shortcutActionOpenMenuLabel),
                onClick: ()=>setIsOpen(true)
            })
    });
};
const $d6eb3e10d21d0abb$var$ShortcutActionMenuUpdated = ({ actions: actions, analyticsName: analyticsName })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [isOpen, setIsOpen] = (0, $42omo.useState)(false);
    const handleClick = (0, $42omo.useCallback)(()=>{
        setIsOpen(true);
        $d6eb3e10d21d0abb$var$fireShortcutActionMenuClickedAnalyticsEvent(createAnalyticsEvent, analyticsName);
    }, [
        createAnalyticsEvent,
        analyticsName,
        setIsOpen
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $lGgRw.Popup), {
        shouldRenderToParent: true,
        isOpen: isOpen,
        onClose: ()=>setIsOpen(false),
        placement: "bottom-start",
        content: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $2SlZp.default), {
                children: actions.map((action, index)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $56M4r.default), {
                        onClick: (e)=>{
                            e.preventDefault();
                            action.onClick?.();
                            setIsOpen(false);
                        },
                        children: action.component
                    }, index))
            }),
        trigger: (triggerProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                ...triggerProps,
                appearance: "subtle",
                spacing: "compact",
                icon: (props)=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($g5gZt))), {
                        ...props,
                        size: "small"
                    }),
                label: formatMessage((0, $bae1ab3d84e6d86e$export$defe85febe8b728c).shortcutActionOpenMenuLabel),
                onClick: handleClick
            })
    });
};
const $d6eb3e10d21d0abb$export$7e648395389e18b0 = (0, $bedQP.componentWithFG)('global_shortcuts_add_actions_click_event', $d6eb3e10d21d0abb$var$ShortcutActionMenuUpdated, $d6eb3e10d21d0abb$var$ShortcutActionMenuDeprecated);





const $d7199daead2261d0$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    disabledItemAriaLabel: {
        id: "navigation.global-shortcuts.menu-link-item.disabled-item-aria-label",
        defaultMessage: "(currently unavailable)"
    },
    loadingItemAriaLabel: {
        id: "navigation.global-shortcuts.menu-link-item.loading-item-aria-label",
        defaultMessage: "(loading)"
    },
    linkExternalIconLabel: {
        id: "navigation.global-shortcuts.menu-link-item.link-external-item-label",
        defaultMessage: "Open external link icon"
    }
});


const $38975b5be28224a9$export$18a13ecc162cd5c2 = (createAnalyticsEvent, analyticsName)=>{
    createAnalyticsEvent({
        eventType: (0, $7TH2w.UI_EVENT_TYPE),
        action: 'clicked',
        actionSubject: 'button',
        actionSubjectId: 'globalNavigation',
        attributes: {
            name: analyticsName
        }
    }).fire((0, $culkJ.ANALYTICS_CHANNEL));
};
const $38975b5be28224a9$var$styles = {
    iconsBlock: "_18zr12x7"
}; /**
    * Utility to return whether actions and options should be shown
    */ 
const $38975b5be28224a9$var$getShouldShowActionsAndOptions = (actions, optionsMenuElem)=>(0, $dh538.fg)('navx-2717-fix-link-icons-disappearing-in-shortcuts') ? actions && actions.length >= 0 || !!optionsMenuElem : true; /**
                                                                                                                                                                                                                                       * Actions and Options component to render both the action menu and options menu
                                                                                                                                                                                                                                       * beside each other on hover/focus
                                                                                                                                                                                                                                       */ 
const $38975b5be28224a9$var$ActionsAndOptions = ({ actions: actions, analyticsName: analyticsName, optionsMenuElem: optionsMenuElem })=>/*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            actions && actions.length && /*#__PURE__*/ (0, $l998X.jsx)((0, $d6eb3e10d21d0abb$export$7e648395389e18b0), {
                actions: actions,
                analyticsName: analyticsName
            }),
            optionsMenuElem
        ]
    });
const $38975b5be28224a9$var$MenuLinkItemComponent = ({ url: url, label: label, labelElem: labelElem, icon: icon, ariaLabel: ariaLabel, actions: actions, onClick: onClick, optionalRef: optionalRef, isSelected: isSelected, openInSameTab: openInSameTab, optionsMenuElem: optionsMenuElem, analyticsName: analyticsName })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const mergedRefs = (0, $3654r.default)(optionalRef ? [
        optionalRef
    ] : []);
    const shouldShowActionsAndOptions = $38975b5be28224a9$var$getShouldShowActionsAndOptions(actions, optionsMenuElem);
    if ((0, $dh538.fg)('navx-1065-global-shortcuts-view-all-apps')) return /*#__PURE__*/ (0, $l998X.jsx)((0, $lujnM.LinkMenuItem), {
        actionsOnHover: /*#__PURE__*/ (0, $l998X.jsx)($38975b5be28224a9$var$ActionsAndOptions, {
            actions: actions,
            analyticsName: analyticsName,
            optionsMenuElem: optionsMenuElem
        }),
        elemBefore: icon,
        elemAfter: !openInSameTab && /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8tdj3))), {
            label: formatMessage((0, $d7199daead2261d0$export$defe85febe8b728c).linkExternalIconLabel),
            size: "small",
            spacing: "spacious"
        }),
        href: url || '',
        target: openInSameTab ? '_self' : '_blank',
        onClick: onClick,
        ref: mergedRefs,
        isSelected: isSelected,
        children: /*#__PURE__*/ (0, $l998X.jsx)("span", {
            "aria-label": ariaLabel,
            children: labelElem ?? label
        })
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $lujnM.LinkMenuItem), {
        actionsOnHover: shouldShowActionsAndOptions && /*#__PURE__*/ (0, $l998X.jsx)($38975b5be28224a9$var$ActionsAndOptions, {
            actions: actions,
            analyticsName: analyticsName,
            optionsMenuElem: optionsMenuElem
        }),
        elemBefore: icon,
        // (handled under FG navx-1065-global-shortcuts-view-all-apps above)
        elemAfter: openInSameTab ? undefined : /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
            xcss: (0, $1Whri.cx)($38975b5be28224a9$var$styles.iconsBlock),
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8tdj3))), {
                label: formatMessage((0, $d7199daead2261d0$export$defe85febe8b728c).linkExternalIconLabel),
                size: "small"
            })
        }),
        href: url || '',
        target: openInSameTab ? '_self' : '_blank',
        onClick: onClick,
        ref: mergedRefs,
        children: /*#__PURE__*/ (0, $l998X.jsx)("span", {
            "aria-label": ariaLabel,
            children: labelElem ?? label
        })
    });
};
const $38975b5be28224a9$var$MenuLinkItemDraggableComponent = ({ url: url, label: label, labelElem: labelElem, icon: icon, ariaLabel: ariaLabel, actions: actions, onClick: onClick, isReorderable: isReorderable, optionalRef: optionalRef, menuItemId: menuItemId, openInSameTab: openInSameTab, optionsMenuElem: optionsMenuElem, analyticsName: analyticsName, isSelected: isSelected })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { enabled: enabled } = (0, $dd4485e00eedab96$export$eae7963fc47ca0d0)();
    const { draggableRef: draggableRef, isDragging: isDragging, maybeDragPreview: maybeDragPreview, dropTargetRef: dropTargetRef, dropIndicator: dropIndicator } = (0, $3H0hg.useL1ItemDragAndDrop)({
        id: menuItemId,
        isExpandable: false,
        isExpandOrFlyoutOpen: false,
        l1DragAndDropEnabled: enabled,
        onExpandFlyoutToggle: ()=>{},
        peek: false,
        item: {
            type: 'link',
            elemBefore: icon,
            label: label,
            labelElem: labelElem,
            href: url || '',
            isReorderable: isReorderable
        },
        group: (0, $fdzcy.L1_MENU_GROUPS).SHORTCUTS
    }); // Can possibly be undefined
    const draggableRefCollection = draggableRef ? [
        draggableRef
    ] : [];
    const mergedRefs = (0, $3654r.default)(optionalRef ? [
        optionalRef,
        ...draggableRefCollection
    ] : [
        ...draggableRefCollection
    ]);
    const shouldShowActionsAndOptions = $38975b5be28224a9$var$getShouldShowActionsAndOptions(actions, optionsMenuElem);
    if ((0, $dh538.fg)('navx-1065-global-shortcuts-view-all-apps')) return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $lujnM.LinkMenuItem), {
                isDragging: isDragging,
                hasDragIndicator: true,
                ref: mergedRefs,
                dropIndicator: dropIndicator,
                visualContentRef: dropTargetRef,
                actionsOnHover: /*#__PURE__*/ (0, $l998X.jsx)($38975b5be28224a9$var$ActionsAndOptions, {
                    actions: actions,
                    analyticsName: analyticsName,
                    optionsMenuElem: optionsMenuElem
                }),
                elemBefore: icon,
                elemAfter: !openInSameTab && /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8tdj3))), {
                    label: formatMessage((0, $d7199daead2261d0$export$defe85febe8b728c).linkExternalIconLabel),
                    size: "small",
                    spacing: "spacious"
                }),
                href: url || '',
                target: openInSameTab ? '_self' : '_blank',
                isSelected: isSelected,
                onClick: onClick,
                children: /*#__PURE__*/ (0, $l998X.jsx)("span", {
                    "aria-label": ariaLabel,
                    children: labelElem ?? label
                })
            }),
            maybeDragPreview
        ]
    });
     // Only render link item if url is defined
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $lujnM.LinkMenuItem), {
                isDragging: isDragging,
                hasDragIndicator: true,
                ref: mergedRefs,
                dropIndicator: dropIndicator,
                visualContentRef: dropTargetRef,
                actionsOnHover: shouldShowActionsAndOptions && /*#__PURE__*/ (0, $l998X.jsx)($38975b5be28224a9$var$ActionsAndOptions, {
                    actions: actions,
                    analyticsName: analyticsName,
                    optionsMenuElem: optionsMenuElem
                }),
                elemBefore: icon,
                elemAfter: openInSameTab ? undefined : /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                    xcss: (0, $1Whri.cx)($38975b5be28224a9$var$styles.iconsBlock),
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8tdj3))), {
                        label: formatMessage((0, $d7199daead2261d0$export$defe85febe8b728c).linkExternalIconLabel),
                        size: "small"
                    })
                }),
                href: url || '',
                target: openInSameTab ? '_self' : '_blank',
                onClick: onClick,
                children: /*#__PURE__*/ (0, $l998X.jsx)("span", {
                    "aria-label": ariaLabel,
                    children: labelElem ?? label
                })
            }),
            maybeDragPreview
        ]
    });
};
const $38975b5be28224a9$export$68ef190193a37bc2 = ({ analyticsName: analyticsName, url: url, label: label, labelElem: labelElem, icon: icon, disabled: disabled, onDisable: onDisable, ariaLabel: ariaLabel, loading: loading, actions: actions, onClick: onClick, onRightClick: onRightClick, onFocus: onFocus, onMouseEnter: onMouseEnter, optionalRef: optionalRef, isReorderable: isReorderable, menuItemId: menuItemId, isSelected: isSelected, product: product = 'globalNavigation', openInSameTab: openInSameTab, optionsMenuElem: optionsMenuElem })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { enabled: enabled } = (0, $dd4485e00eedab96$export$eae7963fc47ca0d0)();
    const analyticsUrlWrapper = (0, $39XmP.default)({
        bridge: 'globalShortcuts',
        product: product
    });
    const getTargetUrl = (0, $42omo.useCallback)((url)=>{
        // For SPA links, we don't want to wrap the URL
        if (!$38975b5be28224a9$var$isValidUrl(url)) return url;
        try {
            const parsedUrl = new URL(url);
            const continueParam = parsedUrl.searchParams.get('continue');
            if (!continueParam) // If there is no continue param, we just wrap the whole URL
            return analyticsUrlWrapper(url);
             // Safely deserialize identity links e.g: https://id.atlassian.com/login?login_hint=...
            const wrappedContinueUrl = analyticsUrlWrapper(continueParam); // Reconstruct the original URL with the wrapped continue param
            parsedUrl.searchParams.set('continue', wrappedContinueUrl);
            return parsedUrl.toString();
        } catch (e) {
            // Gracefully handle any URL parsing errors by returning the original URL
            // TODO: Log error to Sentry
            return url;
        }
    }, [
        analyticsUrlWrapper
    ]);
    const onClickMenuLinkItem = (0, $42omo.useCallback)((event)=>{
        $38975b5be28224a9$export$18a13ecc162cd5c2(createAnalyticsEvent, analyticsName);
        onClick?.(event);
    }, [
        createAnalyticsEvent,
        analyticsName,
        onClick
    ]); // If loading is true, we want to render a representation of the button
    if (loading === true) return /*#__PURE__*/ (0, $l998X.jsx)((0, $c9a9a1032b23ec6d$export$6c62e509491f8f00), {
        icon: icon,
        label: labelElem ?? label,
        showLinkIcon: true
    });
     // Don't render anything if url is undefined or empty, and disabled is not explicitly set to true
    if ((!url || url === '') && !disabled) return null;
     // Render disabled items if no url and/or disabled is true
    if (!url || disabled) {
        if (!url || url === '') onDisable?.('Invalid URL');
        else onDisable?.();
        return /*#__PURE__*/ (0, $l998X.jsxs)((0, $iI2ST.ButtonMenuItem), {
            elemBefore: icon,
            isDisabled: true,
            children: [
                labelElem ?? label,
                /*#__PURE__*/ (0, $l998X.jsx)("span", {
                    "aria-label": formatMessage((0, $d7199daead2261d0$export$defe85febe8b728c).disabledItemAriaLabel)
                })
            ]
        });
    }
    const targetUrl = getTargetUrl(url);
    if ((0, $dh538.fg)('teams-shortcut-next-confluence')) return /*#__PURE__*/ (0, $l998X.jsx)((0, $5b328a77149103a7$export$8209b3c2d1620841), {
        onRightClick: onRightClick,
        onMouseEnter: onMouseEnter,
        onFocus: onFocus,
        children: enabled && menuItemId ? /*#__PURE__*/ (0, $l998X.jsx)($38975b5be28224a9$var$MenuLinkItemDraggableComponent, {
            optionalRef: optionalRef,
            url: targetUrl,
            icon: icon,
            ariaLabel: ariaLabel,
            label: label,
            labelElem: labelElem,
            actions: actions,
            onClick: onClickMenuLinkItem,
            isReorderable: isReorderable,
            isSelected: (0, $dh538.fg)('navx-1065-global-shortcuts-view-all-apps') ? isSelected : undefined,
            menuItemId: menuItemId,
            openInSameTab: openInSameTab
        }) : /*#__PURE__*/ (0, $l998X.jsx)($38975b5be28224a9$var$MenuLinkItemComponent, {
            optionalRef: optionalRef,
            url: targetUrl,
            icon: icon,
            ariaLabel: ariaLabel,
            label: label,
            labelElem: labelElem,
            actions: actions,
            onClick: onClickMenuLinkItem,
            isReorderable: isReorderable,
            isSelected: (0, $dh538.fg)('navx-1065-global-shortcuts-view-all-apps') ? isSelected : undefined,
            openInSameTab: openInSameTab
        })
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $5b328a77149103a7$export$8209b3c2d1620841), {
        handler: onRightClick,
        children: enabled && menuItemId ? /*#__PURE__*/ (0, $l998X.jsx)($38975b5be28224a9$var$MenuLinkItemDraggableComponent, {
            optionalRef: optionalRef,
            url: targetUrl,
            icon: icon,
            ariaLabel: ariaLabel,
            label: label,
            labelElem: labelElem,
            actions: actions,
            onClick: onClickMenuLinkItem,
            isReorderable: isReorderable,
            menuItemId: menuItemId,
            isSelected: (0, $dh538.fg)('navx-1065-global-shortcuts-view-all-apps') ? isSelected : undefined,
            openInSameTab: openInSameTab,
            optionsMenuElem: optionsMenuElem,
            analyticsName: analyticsName
        }) : /*#__PURE__*/ (0, $l998X.jsx)($38975b5be28224a9$var$MenuLinkItemComponent, {
            optionalRef: optionalRef,
            url: targetUrl,
            icon: icon,
            ariaLabel: ariaLabel,
            label: label,
            labelElem: labelElem,
            actions: actions,
            onClick: onClickMenuLinkItem,
            isReorderable: isReorderable,
            isSelected: (0, $dh538.fg)('navx-1065-global-shortcuts-view-all-apps') ? isSelected : undefined,
            openInSameTab: openInSameTab,
            optionsMenuElem: optionsMenuElem,
            analyticsName: analyticsName
        })
    });
};
const $38975b5be28224a9$var$isValidUrl = (urlString)=>{
    if (typeof urlString !== 'string') return false;
    try {
        return Boolean(new URL(urlString));
    } catch (e) {
        return false;
    }
};



/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");







var $bUlM5 = parcelRequire("bUlM5");

const $2059564238074a0d$var$styles = {
    heading: "_11c82smr _1rjcu2gc _19bv12x7 _ca0qu2gc _n3tdu2gc _syazazsu _k48p1pd9 _1e0c1txw _4cvr1h6o"
};
const $2059564238074a0d$export$4b1545b4f2016d26 = ({ children: children, label: label })=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $bUlM5.default), {
        direction: "column",
        children: [
            label && /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                xcss: (0, $1Whri.cx)($2059564238074a0d$var$styles.heading),
                children: label
            }),
            children
        ]
    });
};





const $95a126794c4e4163$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    allSites: {
        id: "navigation.global-shortcuts.all-sites",
        defaultMessage: "All sites"
    },
    closeButtonAriaLabel: {
        id: "navigation.global-shortcuts.menu-expand-item.close-button-aria-label",
        defaultMessage: "Close"
    },
    siteAriaLabel: {
        id: "navigation.global-shortcuts.menu-expand-item.site-aria-label",
        defaultMessage: "{name} site"
    }
});


const $0d4f155f095a22b6$var$styles = {
    root: "_otyr1b66"
};
const $0d4f155f095a22b6$export$3b6395e687b929ba = ({ icon: icon, label: label, labelElem: labelElem, analyticsName: analyticsName, items: items, disabled: disabled, onDisable: onDisable, promotedItem: promotedItem, loading: loading, onClick: onClick, optionalRef: optionalRef, product: product })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const mergedRefs = (0, $3654r.default)(optionalRef ? [
        optionalRef
    ] : []);
    const [isOpen, setIsOpen] = (0, $42omo.useState)(false);
    const closeFlyout = (0, $42omo.useCallback)(()=>setIsOpen(false), []);
    const toggleFlyout = (0, $42omo.useCallback)(()=>{
        createAnalyticsEvent({
            eventType: (0, $7TH2w.UI_EVENT_TYPE),
            action: 'clicked',
            actionSubject: 'globalNavigation',
            actionSubjectId: 'navigationItem',
            attributes: {
                name: analyticsName,
                isExpanding: !isOpen
            }
        }).fire((0, $culkJ.ANALYTICS_CHANNEL));
        setIsOpen((prev)=>!prev);
        onClick?.();
    }, [
        createAnalyticsEvent,
        analyticsName,
        isOpen,
        onClick
    ]);
    const createLinkItem = (0, $42omo.useCallback)((shortcut, index)=>{
        if (shortcut.type === 'expand') return /*#__PURE__*/ (0, $l998X.jsx)($0d4f155f095a22b6$export$3b6395e687b929ba, {
            icon: shortcut.icon,
            label: shortcut.label,
            labelElem: shortcut.labelElem,
            items: shortcut.items,
            disabled: disabled,
            analyticsName: analyticsName,
            onClick: shortcut.onClick,
            onRightClick: shortcut.onRightClick,
            product: product
        }, `shortcut-${index}`);
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $38975b5be28224a9$export$68ef190193a37bc2), {
            apsKey: shortcut.apsKey,
            icon: shortcut.icon,
            url: (0, $gFauz.getUrlMaybe)(shortcut),
            label: shortcut.label,
            labelElem: shortcut.labelElem,
            disabled: disabled,
            ariaLabel: formatMessage((0, $95a126794c4e4163$export$defe85febe8b728c).siteAriaLabel, {
                name: shortcut.label
            }),
            analyticsName: analyticsName,
            onClick: shortcut.onClick,
            onRightClick: shortcut.onRightClick,
            product: product
        }, shortcut?.apsKey ?? `shortcut-${index}`);
    }, [
        analyticsName,
        disabled,
        formatMessage,
        product
    ]); // If loading state then show loading placeholder
    if (loading === true) return /*#__PURE__*/ (0, $l998X.jsx)((0, $c9a9a1032b23ec6d$export$6c62e509491f8f00), {
        icon: icon,
        label: labelElem ?? label
    });
    if (disabled) {
        onDisable?.();
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $iI2ST.ButtonMenuItem), {
            elemBefore: icon,
            isDisabled: true,
            children: labelElem ?? label
        });
    }
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $h0OZ6.FlyoutMenuItem), {
        isOpen: isOpen,
        onOpenChange: setIsOpen,
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $f4c6t.FlyoutMenuItemTrigger), {
                ref: mergedRefs,
                elemBefore: icon,
                onClick: toggleFlyout,
                children: labelElem ?? label
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $580cg.FlyoutMenuItemContent), {
                onClose: closeFlyout,
                children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $8a78adbc066f498f$export$479f0f2f71193efe), {
                    heading: labelElem ?? label,
                    children: [
                        promotedItem && /*#__PURE__*/ (0, $l998X.jsx)((0, $2059564238074a0d$export$4b1545b4f2016d26), {
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $9kbAI.MenuList), {
                                children: createLinkItem(promotedItem, 1)
                            }, "gas-promoted-sites")
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $2059564238074a0d$export$4b1545b4f2016d26), {
                            label: formatMessage((0, $95a126794c4e4163$export$defe85febe8b728c).allSites),
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $9kbAI.MenuList), {
                                children: items?.map(createLinkItem)
                            }, "gas-all-sites")
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                            xcss: (0, $1Whri.cx)($0d4f155f095a22b6$var$styles.root),
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                                shouldFitContainer: true,
                                appearance: "default",
                                onClick: closeFlyout,
                                children: formatMessage((0, $95a126794c4e4163$export$defe85febe8b728c).closeButtonAriaLabel)
                            })
                        })
                    ]
                })
            })
        ]
    });
};






const $7614326872455d2b$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    menuLinkItemAriaLabel: {
        id: "navigation.global-shortcuts.shortcut-link-item.aria-label",
        defaultMessage: "{appName}{siteName}"
    }
});


function $5a702e671347a15f$export$af94fce1535255cc(props) {
    return /*#__PURE__*/ (0, $l998X.jsx)($5a702e671347a15f$var$ConditionalNavErrorBoundary, {
        location: (0, $dBtY8.ERROR_LOCATION__GLOBAL_SHORTCUTS),
        showFlags: true,
        sentryConfig: {
            product: props?.product
        },
        children: /*#__PURE__*/ (0, $l998X.jsx)($5a702e671347a15f$var$ShortcutMenuItemInner, {
            ...props
        })
    });
}
function $5a702e671347a15f$var$ShortcutMenuItemInner({ shortcut: shortcut, status: status, expandItems: expandItems, forceStatic: forceStatic, promotedItem: promotedItem, siteName: siteName, product: product, openInSameTab: openInSameTab }) {
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const analyticsName = shortcut.analyticsName || `unknown_${shortcut.label}`;
    const ItemWrapper = shortcut?.ItemWrapper ?? (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment;
    const siteNameAriaLabel = siteName ? ` (${siteName})` : '';
    /**
   * If the data provider is being initialised or loading, we want to display a placeholder item with a spinner.
   */ const loading = (0, $42omo.useMemo)(()=>!!(!forceStatic && status && (status === (0, $4jETc.RequestStatus).INIT || status === (0, $4jETc.RequestStatus).LOADING)), [
        status,
        forceStatic
    ]);
    /**
   * Set disabled state based on what we know at this point
   * from whether we are forcing static rendering and the status of the BFF request.
   * If we have more conditions received from the BFF in the future (such as permissions), we can account for those here too.
   */ const disabled = (0, $42omo.useMemo)(()=>{
        // If forceStatic is explicitly set to true, do not disable the item
        if (forceStatic) return false;
        // Do not explicitly disable links that have empty URLs, because we don't want to display them at all
        // todo: Should we include undefined URLs and fallback URLs?
        if (shortcut.type === 'link') {
            if ((0, $kVqQ6.getFallbackUrlMaybe)(shortcut.fallbackUrl) !== undefined) return false;
        }
        // Only show disabled state when the BFF request is complete and fails
        if (status === (0, $4jETc.RequestStatus).ERROR) return true;
        if (forceStatic === undefined) return false;
        return !forceStatic;
    }, [
        forceStatic,
        shortcut,
        status
    ]);
    /**
   * An event to pass down to the inner menu item component (MenuLinkItem or MenuExpandItem) to be called when the item is disabled.
   * This allows the inner components to handle further disabling conditions within themselves if applicable,
   * and optionally pass up a reason for the disabled state determined within itself.
   * If no reason is passed, we check against what we know here from the data received from the BFF.
   */ const onDisable = (0, $42omo.useCallback)((reason)=>{
        // Do not fire analytics event until loading is complete
        if (!status || status === (0, $4jETc.RequestStatus).INIT || status === (0, $4jETc.RequestStatus).LOADING) return;
        // This currently covers reasons like request errors.
        // If the BFF gives us more information in the future (such as permissions), that should be accounted for here too.
        const bffReason = status !== (0, $4jETc.RequestStatus).COMPLETE ? status : undefined;
        createAnalyticsEvent({
            eventType: (0, $7TH2w.UI_EVENT_TYPE),
            action: 'disabled',
            actionSubject: 'button',
            actionSubjectId: 'globalNavigation',
            attributes: {
                name: analyticsName,
                reason: reason ?? bffReason
            }
        }).fire((0, $culkJ.ANALYTICS_CHANNEL));
    }, [
        createAnalyticsEvent,
        analyticsName,
        status
    ]);
    if (shortcut.type === 'component') {
        const Component = shortcut.component;
        return /*#__PURE__*/ (0, $l998X.jsx)(ItemWrapper, {
            children: /*#__PURE__*/ (0, $l998X.jsx)(Component, {
                onClick: ()=>{
                    (0, $38975b5be28224a9$export$18a13ecc162cd5c2)(createAnalyticsEvent, analyticsName);
                    shortcut.onClick?.();
                }
            })
        });
    }
    if (shortcut.type === 'expand') return /*#__PURE__*/ (0, $l998X.jsx)(ItemWrapper, {
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $0d4f155f095a22b6$export$3b6395e687b929ba), {
            optionalRef: shortcut.ref,
            analyticsName: analyticsName,
            icon: shortcut.icon,
            label: shortcut.label,
            labelElem: shortcut.labelElem,
            items: expandItems,
            disabled: disabled,
            onDisable: onDisable,
            promotedItem: promotedItem,
            loading: loading,
            onClick: shortcut.onClick,
            onRightClick: shortcut.onRightClick,
            product: product
        }, shortcut.key)
    });
    if (shortcut.type === 'internal') return /*#__PURE__*/ (0, $l998X.jsx)(ItemWrapper, {
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $38975b5be28224a9$export$68ef190193a37bc2), {
            analyticsName: analyticsName,
            disabled: disabled,
            icon: shortcut.icon,
            url: (0, $gFauz.getUrlMaybe)(shortcut),
            label: shortcut.label,
            labelElem: shortcut.labelElem,
            onDisable: onDisable,
            loading: loading,
            isReorderable: shortcut.isReorderable,
            openInSameTab: true,
            onClick: shortcut.onClick,
            onRightClick: shortcut.onRightClick,
            product: product,
            isSelected: shortcut.isSelected
        }, shortcut.key)
    });
    return /*#__PURE__*/ (0, $l998X.jsx)(ItemWrapper, {
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $38975b5be28224a9$export$68ef190193a37bc2), {
            optionalRef: shortcut.ref,
            analyticsName: analyticsName,
            disabled: disabled,
            apsKey: shortcut.apsKey,
            icon: shortcut.icon,
            url: (0, $gFauz.getUrlMaybe)(shortcut),
            label: shortcut.label,
            labelElem: shortcut.labelElem,
            onDisable: onDisable,
            loading: loading,
            actions: shortcut.actions,
            ariaLabel: formatMessage((0, $7614326872455d2b$export$defe85febe8b728c).menuLinkItemAriaLabel, {
                appName: shortcut.label,
                siteName: siteNameAriaLabel
            }),
            onClick: shortcut.onClick,
            isReorderable: shortcut.isReorderable,
            onRightClick: shortcut.onRightClick,
            onMouseEnter: shortcut.onMouseEnter,
            onFocus: shortcut.onFocus,
            menuItemId: shortcut.menuItemId,
            product: product,
            openInSameTab: openInSameTab,
            optionsMenuElem: shortcut.optionsMenuElem
        }, shortcut.key)
    });
}
const $5a702e671347a15f$var$ConditionalNavErrorBoundary = (0, $bedQP.componentWithFG)('navx-1574-navigation-error-boundary-shortcuts', (0, $5xxOu.NavErrorBoundary), ({ children: children })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Fragment), {
        children: children
    }));
module.exports["ShortcutMenuItem"] = $5a702e671347a15f$export$af94fce1535255cc;

});

parcelRegister("4NsV7", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::852a07e098801d09532a079dc210ca17>>
 * @codegenCommand yarn workspace @atlassian/analytics-tooling run analytics:codegen navigation-common
 */ 
var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $aHlaw = parcelRequire("aHlaw");


var $5YXCb = parcelRequire("5YXCb");

const $26d2654a80668b7e$export$5bf35293e545f20c = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const fireEvent = (0, $42omo.useCallback)((...params)=>{
        const event = createAnalyticsEvent((0, $5YXCb.default)(...params));
        event.fire((0, $aHlaw.EVENT_CHANNEL));
    }, [
        createAnalyticsEvent
    ]);
    return {
        fireEvent: fireEvent
    };
};
module.exports["useAnalyticsEvents"] = $26d2654a80668b7e$export$5bf35293e545f20c;

});

parcelRegister("kVqQ6", function(module, exports) {

var $8wX8z = parcelRequire("8wX8z");

const $7835b86ae1a8768a$export$1f32ba41e2b31f39 = (fallbackUrl)=>{
    if (fallbackUrl === undefined) return undefined;
    return (0, $8wX8z.getFallbackUrl)(fallbackUrl);
};
module.exports["getFallbackUrlMaybe"] = $7835b86ae1a8768a$export$1f32ba41e2b31f39;

});

parcelRegister("geKgP", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");

const $99893fecde08ccf3$export$c69308b19dea1022 = /*#__PURE__*/ (0, $42omo.createContext)({
    enabled: false
});
const $99893fecde08ccf3$export$b40e2d2385213009 = ({ children: children, enabled: enabled = false })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)($99893fecde08ccf3$export$c69308b19dea1022.Provider, {
        value: {
            enabled: enabled
        },
        children: children
    });
};
module.exports["DragAndDropOptionsContext"] = $99893fecde08ccf3$export$c69308b19dea1022;
module.exports["DragAndDropOptionsProvider"] = $99893fecde08ccf3$export$b40e2d2385213009;

});

parcelRegister("aHlaw", function(module, exports) {
const $718bd7cb44a047b4$export$3f072f06b90c3985 = 'navigation';
module.exports["EVENT_CHANNEL"] = $718bd7cb44a047b4$export$3f072f06b90c3985;

});

parcelRegister("5YXCb", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::85436479424fa726e1c817d9c4b6af72>>
 * @codegenCommand yarn workspace @atlassian/analytics-tooling run analytics:codegen navigation-common
 */ const $246134791e2b1d20$var$createEventPayload = (eventKey, ...[attributes])=>{
    const [eventType, actionSubject, action, actionSubjectId] = eventKey.split('.');
    if (eventType === 'screen') return {
        eventType: eventType,
        name: actionSubject,
        action: 'viewed',
        attributes: attributes
    };
    return {
        eventType: eventType,
        actionSubject: actionSubject,
        action: action,
        actionSubjectId: actionSubjectId,
        attributes: attributes
    };
};
var $246134791e2b1d20$export$2e2bcd8739ae039 = $246134791e2b1d20$var$createEventPayload;
module.exports["default"] = $246134791e2b1d20$export$2e2bcd8739ae039;

});

parcelRegister("8wX8z", function(module, exports) {
const $2608e69a137afd0b$export$739b3f561aa47bc9 = (fallbackUrl)=>{
    if (typeof fallbackUrl === 'function') return fallbackUrl();
    // `fallbackUrl` is a string, return it directly
    return fallbackUrl;
};
module.exports["getFallbackUrl"] = $2608e69a137afd0b$export$739b3f561aa47bc9;

});


//# sourceMappingURL=ConversationAssistant.59853c6f.js.map
